// eslint-disable-next-line import/no-duplicates
import { create, Matrix, MathNode, MathJsStatic, MathArray } from "mathjs";
import {
    isIntegerDependencies,
    isNegativeDependencies,
    isNumericDependencies,
    isPositiveDependencies,
    isZeroDependencies,
    isNaNDependencies,
    numberDependencies,
    stringDependencies,
    booleanDependencies,
    absDependencies,
    ceilDependencies,
    floorDependencies,
    multiplyDependencies,
    subtractDependencies,
    orDependencies,
    concatDependencies,
    flattenDependencies,
    sizeDependencies,
    squeezeDependencies,
    numericDependencies,
    roundDependencies,
    andDependencies,
    compareDependencies,
    compareTextDependencies,
    equalDependencies,
    equalTextDependencies,
    unequalDependencies,
    maxDependencies,
    minDependencies,
    addDependencies,
    dotDependencies,
    parseDependencies,
    compileDependencies,
    evaluateDependencies,
    parserDependencies,
    divideDependencies,
    sumDependencies,
    meanDependencies,
    falseDependencies,
    nullDependencies,
    trueDependencies,
    applyDependencies,
    notDependencies,
    columnDependencies,
    filterDependencies,
    indexTransformDependencies,
    // eslint-disable-next-line import/no-duplicates
} from "mathjs";
import lodashMemoize from "lodash/memoize";
import memoizeOne from "memoize-one";
import moment from "moment";
import fp from "lodash/fp";
import _, { isArray, get, set, map, template, memoize, merge, uniq } from "lodash";
import { List, Set, Map as ImmutableMap, fromJS, OrderedMap, OrderedSet, Iterable, Map } from "immutable";

import {
    RowNode,
    ColDef,
    GridApi,
    ValueGetterParams,
    ColumnApi,
    Column,
    ICellRendererParams,
    CellRendererSelectorFunc,
    ICellRendererFunc,
    ColumnModel,
    CellClassFunc,
    CellClassParams,
    ApplyColumnStateParams,
} from "ag-grid-community";
import {
    AggFuncs,
    CardView,
    DetailView,
    Kinds,
    ValueTypes,
    EXCEL_STYLES,
    Item,
    NAMESPACE_KEYS,
    SizeCurveStatus,
    SizingErrors,
    SizeCurveMethod,
    SizeRangesErrors,
    Editors,
    SeverityMessages,
    IField,
    SchemaField,
    ItemFields,
    GridParamType,
    SELECTED_SIZES_DELIMITER,
    MANUALLY_ADDED_SIZES_DELIMITER,
    IMAGE_URL,
    PoiTag,
    ExportCollectionSelectedSetting,
    ALLOCATION_DIMENSION_ID_PREFIX,
    CurrencyDictionary,
    CAPTURED_BULKS,
    SIZE_PACKS_DELIMITER,
    IGridItem,
    IDefaultItem,
    SIZE_PACKS_STATE_PATH,
    SIZE_PACKS_EACHES,
    IItemField,
    ItemValidationErrors,
    ShopView,
    TILE_VIEW_IMAGE_HEIGHT_SMALL,
    TILE_VIEW_IMAGE_HEIGHT_MEDIUM,
    TILE_VIEW_IMAGE_HEIGHT_LARGE,
    TILE_VIEW_IMAGE_WIDTH_SMALL,
    TILE_VIEW_IMAGE_WIDTH_MEDIUM,
    TILE_VIEW_IMAGE_WIDTH_LARGE,
    TileViewSize,
    PinnedDto,
    ValidationModes,
    ValidationLevel,
    IMAGE_COLUMN_MIN_WIDTH,
    IMAGE_COLUMN_MAX_WIDTH,
    SIZES_ORDER_REFERENCE,
    TILE_VIEW_ITEM_SIZES,
    ALLOCATION_BAG_REF_CONTEXT_ATTRIBUTE,
    IExportParams,
    TotalPps,
    PPS_INDICATOR,
} from "constants/product-collection";
import { ILookup, ILookupWhere, ILookupWhereField, ILookupTerm, ILookupRawData } from "helpers/merchant/lookup/types";
import { formatMessage, format, formatCurrency, formatNumber } from "lib/globalize-util";
import { ISuggestionItem } from "containers/product-collections/product-collection-cart";
import {
    formatDecimals,
    formatThousands,
    roundValue,
    safeFormatNumber,
    safeParseFloat,
    safeParseInt,
} from "lib/number";
import {
    isDimensionInFilters,
    isDoorColumn,
    MENU_GENERAL_TAB_ONLY,
    PURCHASE_ORDER_DOOR_GROUP_FIELD,
    IDoorTotal,
} from "./door-collection";

import uuid from "uuid/v4";
import validator from "validator";
import * as Sentry from "@sentry/browser"; // error tacking
import { getInternalLookUp } from "./internal-lookups";
import { getFieldValue } from "helpers/collection";
import { areAllItemsContainedInList, amphibiousGetIn, amphibiousToJS, ImmutableIterable } from "./objUtils";
import { ISizeRange } from "actions/collections";
import {
    IAllocationDimension,
    AllocationDimensionKind,
    getGetterBreadcrumbs,
    matchBreadcrumbs,
    AllocationBagType,
    forEachAllocationBag,
    BAG_VALUE_PARAMS_SEPARATOR,
    getAllocationBagValue,
    AllocationBag,
    isAllocationDimensionId,
} from "helpers/allocation-dimension";
import { tableValueGetter } from "helpers/table-bag";
import { IGridParamsQueryParam } from "components/product-collection/product-collection-views/product-collection-grid-view/tool-panels/data-view-panel/grid-param-helpers";
import { getStore } from "store";
import {
    defaultValueSetter,
    dateValueSetter,
    checkType,
} from "components/product-collection/product-collection-views/product-collection-grid-view/product-collection-grid-view";
import { MEDIA_TYPE_360, MEDIA_TYPE_IMAGE, MEDIA_TYPE_VIDEO } from "constants/media";
import { IProduct, MEDIA_MAP, withVideoSize, IVariant } from "records/item/item";
import { IProductMedia } from "constants/product-media";
import { ICollectionSwatch } from "constants/color-swatches";
import { itemHasEmptyUPCsorNRFs } from "./sizing";
import {
    DEFAULT_VALUES_PINNED_ROW,
    SIZE_TOTALS_IDENTIFIER,
} from "components/product-collection/product-collection-views/product-collection-grid-view/detail-list/helpers";
import {
    validateItemsWithFieldValidations,
    ValidationResultWithIdentifier,
    validationsCellClassFactory,
} from "./product-collection/field_validation";
import { CollectionPOI } from "records/collection/poi";
import { ICollectionVersionStatus } from "./collection-version-status";
import {
    CloseoutColumns,
    ColumnTypes,
    getNewResizedImageCellDimensions,
} from "components/product-collection/product-collection-views/product-collection-grid-view/product-collection-grid-view-helper";
import {
    IDate,
    isValidDateFormat,
} from "components/product-collection/product-collection-views/product-collection-grid-view/grid-editors/editor-helper";
import { IChoiceValue } from "components/product-collection/product-collection-views/product-collection-grid-view/grid-editors/single-choice-cell-editor";
import { IPackInfo, PackTypes } from "reducers/collection";
import { generateStoreKey, getTransformedLookupValueByType } from "./internal-lookups/size-curves-lookup";
import { nullish } from "./nullish";
import { fetchJSON } from "lib/fetch";
import { buildFilterValuesQuery } from "./query-dsl-builder";
import { RollupType } from "containers/folders/types/server-rollups";
import {
    AGGREGATE_COLUMN_PREFIX,
    ASSORTMENT_FIELD_NAME,
    ASSORTMENT_NAME_DELIMITER,
    COLLECTION_ID_FIELD_NAME,
    DEFAULT_DATE_VALUE,
    getBlankTextValue,
    getGroupKeyValue,
    getServerRollupEndpoint,
    isBlankValue,
    parseStringIntoDate,
    SERVER_SNAPSHOT_DATE_F0RMAT,
    UNSET_GROUP_KEY,
} from "./server-rollup";
import { IImageCellDimensions } from "constants/types";
import {
    validateItemsWithRowValidations,
    validateCollectionProperties,
    IValidationCollectionData,
} from "./product-collection/row-validation";
import { validationLogic } from "./product-collection/validation-formulas";
import { isStringAggregationFunction } from "components/product-collection/product-collection-views/product-collection-grid-view/grid-renderers/render-utils";
import {
    SHOW_DOORS,
    SHOW_TOTAL_COST,
    SHOW_TOTAL_RETAIL,
    SHOW_UNITS,
} from "components/product-collection/manage-tile-view/constants";
import { getSortModelFromApi } from "./ag-grid";
import { getMetricColIdSuffix } from "./metrics/column-formula/ag-grid-helper";
import { ASSORTMENT_TOTALS_ROW } from "components/product-collection/product-collection-views/product-collection-grid-view/grid-renderers/pinned-row-renderers";
import { IGridItem as CartGridItem } from "./legacy-cart/line-items/items-conversion-helper";
import lodashCloneDeep from "lodash/cloneDeep";
import { FinancialTargetFilter } from "components/product-collection/footer/types";
import { ColumnsKinds } from "constants/sizingView";
import { IGridEntry } from "types/cart/shipment-review";
import { getSizeLabel } from "containers/legacy-cart/helpers/gridEntry";
import { getTotalsFromEntries, ItemTotalType } from "containers/legacy-cart/helpers";

export const collectionMathJs = create(
    {
        indexTransformDependencies,
        isIntegerDependencies,
        isNegativeDependencies,
        isNumericDependencies,
        isPositiveDependencies,
        isZeroDependencies,
        isNaNDependencies,
        numberDependencies,
        stringDependencies,
        booleanDependencies,
        absDependencies,
        ceilDependencies,
        floorDependencies,
        multiplyDependencies,
        subtractDependencies,
        orDependencies,
        concatDependencies,
        flattenDependencies,
        sizeDependencies,
        squeezeDependencies,
        numericDependencies,
        roundDependencies,
        andDependencies,
        compareDependencies,
        compareTextDependencies,
        equalDependencies,
        equalTextDependencies,
        unequalDependencies,
        maxDependencies,
        minDependencies,
        addDependencies,
        dotDependencies,
        parseDependencies,
        compileDependencies,
        evaluateDependencies,
        parserDependencies,
        divideDependencies,
        sumDependencies,
        meanDependencies,
        falseDependencies,
        nullDependencies,
        trueDependencies,
        applyDependencies,
        notDependencies,
        columnDependencies,
        filterDependencies,
    },
    {}
);

export const getNamespace = (collectionId: string, userId: string, merchantId: string, key: NAMESPACE_KEYS) => {
    return `PRODUCT_COLLECTION/${collectionId}/${userId}/${merchantId}/${key}`;
};

export const getValueFromLocalStorage = (
    collectionId: string,
    userId: string,
    merchantId: string,
    key: NAMESPACE_KEYS,
    defaultValue?
) => {
    return window.localStorage.getItem(getNamespace(collectionId, userId, merchantId, key)) || defaultValue;
};

export const setValueToLocalStorage = (
    collectionId: string,
    userId: string,
    merchantId: string,
    key: NAMESPACE_KEYS,
    value
) => {
    return window.localStorage.setItem(getNamespace(collectionId, userId, merchantId, key), value);
};

// Editors will handle their own events since they use React synthetic events and not DOM ones
// Update - Dont think this is needed but will keep this in for now
// export const handleSuppressKeyboardEvent = (params) => {
//     const suppressKeyboardEvent = params.editing;
//     return suppressKeyboardEvent;
// };

export const editableCellIsEditable = (params) => {
    const { node, column, data } = params;
    if (node.rowPinned === "top" && (column.colId.match("_total_units") || data?.type === DEFAULT_VALUES_PINNED_ROW)) {
        return true;
    }
    return !node.rowPinned;
};

export const editableCellNotEditable = (params) => {
    const { node, column } = params;

    return !!(node.rowPinned === "top" && column.colId.match("_total_units"));
};

export enum PinnedValue {
    UNPINNED = "unpinned",
    LEFT = "left",
    RIGHT = "right",
}

/**
 * Returns client representation of pinned status
 */
export const getPinnedValue = (pinned: string) => {
    switch (pinned) {
        case PinnedDto.UNPINNED:
            return PinnedValue.UNPINNED;
        case PinnedDto.LEFT:
            return PinnedValue.LEFT;
        case PinnedDto.RIGHT:
            return PinnedValue.RIGHT;
        default:
            return PinnedValue.UNPINNED;
    }
};

/**
 * Returns server representation of pinned status
 */
export const getPinnedDto = (pinned: string) => {
    switch (pinned) {
        case PinnedValue.UNPINNED:
            return PinnedDto.UNPINNED;
        case PinnedValue.LEFT:
            return PinnedDto.LEFT;
        case PinnedValue.RIGHT:
            return PinnedDto.RIGHT;
        default:
            return PinnedDto.UNPINNED;
    }
};

export interface IDiffDeptChecker {
    firstDiffDeptValue: string;
    fieldName: string;
}
export interface ISchemaToGridParams {
    gridParams: IGridParamsQueryParam;
    allowedValueFields: any;
    openDetailModal: (id: string, assortmentId?: string, nodeRowIndex?: number) => void;
    gridEditable: boolean;
    validate: any;
    diffDeptChecker?: IDiffDeptChecker;
    allocationDimensions?: IAllocationDimension[];
    dimensionPlanMetrics?: string[];
    dimensionFilters?: string[][];
    defaultDateFormat?: string;
    isServerSide?: boolean;
    isGridTileView?: boolean;
    collectionId?: string;
    merchantId?: string;
    useConstraintValues?: boolean;
    inventoryEnabled?: boolean;
    isRollupMode?: boolean;
    imageHeaderComponent?: string;
    rawItemDisplayProperty?: any;
    ignoreImageValidate?: boolean;
    enableImageHeaderMenu?: boolean;
}

export interface IGridColumn {
    expand: boolean;
    show_filter_box: boolean;
    show_filter_set: boolean;
    pinned: PinnedDto | PinnedValue;
    width: number;
}

export interface ISchemeDisplay {
    enable_aggregation: boolean;
    enable_group_by: boolean;
    enable_pivot: boolean;
    hidden: boolean;
    read_only: boolean;
    is_user_defined?: boolean;
}
export interface ICardView {
    is_cost: boolean;
    is_text: boolean;
    is_title: boolean;
    allow_group: boolean;
    is_action: boolean;
    is_subtitle: boolean;
    is_color: boolean;
    allow_filter: boolean;
    is_media: boolean;
    is_total_retail: boolean;
    allow_sort: boolean;
    is_subtext: boolean;
    is_retail: boolean;
    is_total_cost: boolean;
    is_total_units: boolean;
}
export interface IDetailView {
    is_size_filter: boolean;
    display: boolean;
    is_cost: boolean;
    is_title: boolean;
    editable: boolean;
    is_subtitle: boolean;
    is_color: boolean;
    is_size_table_column: boolean;
    is_total_retail: boolean;
    is_retail: boolean;
    is_total_cost: boolean;
    is_variation: boolean;
    is_total_units: boolean;
}

export interface ICsvView {
    header_name: string;
    hidden: false;
}

export interface INumberFormat {
    percentage?: {
        decimal_places: number;
    };
    currency?: {
        currency_code?: string;
        decimal_places: number;
        symbol: string;
    };
}

export interface IShopView {
    is_cost: boolean;
    is_text: boolean;
    is_title: boolean;
    allow_group: boolean;
    is_action: boolean;
    is_subtitle: boolean;
    is_color: boolean;
    allow_filter: boolean;
    is_media: boolean;
    is_total_retail: boolean;
    allow_sort: boolean;
    is_subtext: boolean;
    is_retail: boolean;
    is_total_cost: boolean;
    is_total_units: boolean;
}

export interface ISchemaKey {
    field_name: string;
    display_name: string;
    value_type: ValueTypes;
    kind: Kinds | ColumnsKinds;
    display: ISchemeDisplay;
    hidden?: boolean;
    formula?: string;
    formulas?: string[];
    groupFormula?: boolean; // apply formulas to group values
    grid_column?: IGridColumn;
    customAggregations?: AggFuncs[];

    constraint?: any;
    display_name_override?: string;
    card_view?: ICardView;
    detail_view?: IDetailView;
    generate_feed_item_on_change?: boolean;
    csv_view?: ICsvView;
    shop_view?: IShopView;
    number_format?: INumberFormat | null;
    allow_override_display_name?: boolean;
    lookup_plan?: ILookup | null;
    field_validations?: nuorder.collection.item_display_property.FieldValidation[];
    field_value_delimiter?: string;
    rowwise_evaluation?: boolean;
    fe_lookup_type?: string;
    collectionId?: string;
    default_smu_value?: {
        string_value: string;
    };
    gridColOptions?: {
        [key: string]: any;
    };
    target_view?: {
        is_target_metric: boolean;
        is_target_type: boolean;
    };
}

export type SchemaKeyMap = Map<keyof ISchemaKey, any>;

export interface ISchemaToGridArg {
    schemaKey: ISchemaKey;
    params: ISchemaToGridParams;
}
const EDITOR_DISPLAY = "dropdown_format";
const DEFAULT_MERCHANT_DATE_FORMAT = "MM/DD/YYYY";

interface IITemField {
    colId: string;
    type: string;
}

// Change getCellRendererSelector first parameter if you add a cellRenderer; use second parameter if you add a pinnedRowCellRenderer
export const getCellRendererSelector = (
    cellRenderer: string | ICellRendererFunc,
    pinnedRowCellRenderer: string | ICellRendererFunc
): CellRendererSelectorFunc => {
    return ({ node, data, colDef }: ICellRendererParams) => {
        if (node.isRowPinned()) {
            if (data?.totalType === ASSORTMENT_TOTALS_ROW) {
                if (colDef.colId !== IMAGE_URL) {
                    return { component: cellRenderer };
                } else {
                    return { component: pinnedRowCellRenderer };
                }
            }
            return {
                component:
                    data?.type === DEFAULT_VALUES_PINNED_ROW && colDef.colId !== IMAGE_URL
                        ? cellRenderer
                        : pinnedRowCellRenderer,
            };
        }
        return { component: cellRenderer };
    };
};

// Use getCellRendererParamsFn first parameter for the cellRendererParams, and the second one for the pinnedRowCellRendererParams
const getCellRendererParamsFn = (cellRendererParams, pinnedCellRendererParams) => {
    return ({ data, node, colDef }: ICellRendererParams) => {
        if (node.isRowPinned()) {
            return data?.type === DEFAULT_VALUES_PINNED_ROW && colDef.colId !== IMAGE_URL
                ? cellRendererParams
                : pinnedCellRendererParams;
        }
        return cellRendererParams;
    };
};

const isInventoryUnitColumn = (kind: Kinds) =>
    [Kinds.INVENTORY_UNITS_PER_SIZE, Kinds.INVENTORY_TOTAL_UNITS, Kinds.INVENTORY_DEFAULT].includes(kind);

interface ISchemaDesiredRequired {
    required: {
        upc: boolean;
        nrf: boolean;
    };
    desired: {
        upc: boolean;
        nrf: boolean;
    };
}

interface ISchemaToGridOptions {
    rowLevelConstraint?: ISchemaDesiredRequired;
}

export const checkRequiredDesired = (itemDisplayProperties: ISchemaKey[]): ISchemaDesiredRequired => {
    const options = {
        required: {
            upc: false,
            nrf: false,
        },
        desired: {
            upc: false,
            nrf: false,
        },
    };
    itemDisplayProperties?.forEach((item) => {
        if (item.field_name === "_upcs" && item.constraint) {
            if (item.constraint.required) {
                options.required.upc = true;
            }
            if (item.constraint.desired) {
                options.desired.upc = true;
            }
        }
        if (item.field_name === "_nrf_size_codes" && item.constraint) {
            if (item.constraint.required) {
                options.required.nrf = true;
            }
            if (item.constraint.desired) {
                options.desired.nrf = true;
            }
        }
    });
    return options;
};

/**
 * Generates column definiton for ag-grid
 */
export const schemaToGrid = ({ schemaKey, params }: ISchemaToGridArg, options?: ISchemaToGridOptions): ColDef => {
    if (
        !schemaKey ||
        ((params.isServerSide || params.isRollupMode || !params.inventoryEnabled) &&
            isInventoryUnitColumn(schemaKey.kind as Kinds))
    ) {
        return;
    }

    const { gridParams, allowedValueFields, dimensionPlanMetrics = [] } = params;
    const { rowGroup, aggFunc, pivot, sort } = gridParams || {};

    const openDetailModal = (e) => {
        const { node } = e;

        if (!node.rowPinned && node.data && params.openDetailModal) {
            const data = amphibiousToJS(node.data);
            const collectionId = params.isServerSide && data.fields?.[COLLECTION_ID_FIELD_NAME]?.string_value;
            data.fields.id && params.openDetailModal(data.fields.id.string_value, collectionId, node.rowIndex);
        }
        return null;
    };

    const editable = isEditable(schemaKey, params.gridEditable);
    const { warningValidations, errorValidations } = (schemaKey.field_validations ?? []).reduce(
        (acc, validation) => {
            if (validation.level === ValidationLevel.WARN) {
                acc.warningValidations.push(validation);
            } else if (validation.level === ValidationLevel.ERROR) {
                acc.errorValidations.push(validation);
            }
            return acc;
        },
        { warningValidations: [], errorValidations: [] }
    );

    // // Return a function in cellRendererParams created with getCellRendererParamsFn if you use a pinnedRowCellRenderer
    const { cellRendererParams, ...additionalAttributes } = getAdditionalAttributes(schemaKey, params);
    const cellRenderer = getCellRenderer(schemaKey);
    const cellEditor = getCellEditor(schemaKey);
    const pinnedCellRendererParams = {
        kind: schemaKey.kind,
        allocationReferenceFields: {
            retailFieldName: get(schemaKey, ["allocation_reference_fields", "retail_field_name"]),
            wholesaleFieldName: get(schemaKey, ["allocation_reference_fields", "cost_field_name"]),
        },
        currency: get(schemaKey, ["number_format", "currency"]),
        dimensionPlanMetrics,
    };

    const serverRollupEndpoint = params.collectionId && getServerRollupEndpoint(params.collectionId);
    const filterDef = getColumnFilter(schemaKey);
    const hideColumn = get(schemaKey, ["hidden"], false) || get(schemaKey, ["display", "hidden"], false);
    return {
        headerName: schemaKey.display_name_override || schemaKey.display_name, // get override display name here if available
        field: schemaKey.field_name,
        cellRendererSelector: getCellRendererSelector(cellRenderer, "customPinnedRowRenderer"),
        cellRendererParams: getCellRendererParamsFn(cellRendererParams, pinnedCellRendererParams),
        cellEditor,
        cellEditorPopup: true,
        ...filterDef,
        floatingFilter: !params.isGridTileView,
        valueGetter: getValueGetter(schemaKey),
        valueSetter: getValueSetter(schemaKey, params),
        valueFormatter: getValueFormatter(schemaKey),
        filterValueGetter: getFilterValueGetter(schemaKey),
        width: get(schemaKey, ["grid_column", "width"], 200) || 200,
        hide: hideColumn,
        suppressColumnsToolPanel: get(schemaKey, ["hidden"], false),
        enableRowGroup: get(schemaKey, ["display", "enable_group_by"], false),
        rowGroupIndex: getRowGroupIndex(rowGroup, schemaKey),
        enablePivot: get(schemaKey, ["display", "enable_pivot"], false),
        pivotIndex: getPivotIndex(pivot, schemaKey),
        enableValue: get(schemaKey, ["display", "enable_aggregation"], false),
        aggFunc: getAggFunction(aggFunc, schemaKey),
        type:
            schemaKey.value_type === ValueTypes.NUMBER && schemaKey.field_name !== CAPTURED_BULKS
                ? "numericColumn"
                : schemaKey.value_type === ValueTypes.DATE
                  ? ColumnTypes.DateColumn
                  : undefined,
        cellClassRules: {
            noValueRequired: (data) => {
                if (!params.validate) {
                    return false;
                }
                let emptyUpcs = false;
                if (
                    data.colDef.colId === IMAGE_URL &&
                    (options?.rowLevelConstraint?.required.nrf || options?.rowLevelConstraint?.required.upc)
                ) {
                    const { nrf, upc } = itemHasEmptyUPCsorNRFs(fromJS(data.data));
                    emptyUpcs =
                        (options?.rowLevelConstraint?.required.nrf && nrf) ||
                        (options?.rowLevelConstraint?.required.upc && upc);
                }
                const required = schemaKey.constraint && schemaKey.constraint.required;
                return (required && !data.value) || emptyUpcs;
            },
            noValueDesired: (data) => {
                if (!params.validate) {
                    return false;
                }
                let emptyUpcs = false;
                if (
                    data.colDef.colId === IMAGE_URL &&
                    (options?.rowLevelConstraint?.desired.nrf || options?.rowLevelConstraint?.desired.upc)
                ) {
                    const { nrf, upc } = itemHasEmptyUPCsorNRFs(fromJS(data.data));
                    emptyUpcs =
                        (options?.rowLevelConstraint?.desired.nrf && nrf) ||
                        (options?.rowLevelConstraint?.desired.upc && upc);
                }
                const desired = schemaKey.constraint && schemaKey.constraint.desired && !schemaKey.constraint.required;
                return (desired && !data.value) || emptyUpcs;
            },
            differentDepartment: (data) => {
                if (!params.diffDeptChecker) {
                    return false;
                }
                const diffValue = params.diffDeptChecker.firstDiffDeptValue;
                const fieldName = params.diffDeptChecker.fieldName;
                return data.colDef.field === fieldName && data.value === diffValue;
            },
            warningValidation: validationsCellClassFactory(warningValidations, schemaKey, editable),
            errorValidation: validationsCellClassFactory(errorValidations, schemaKey, editable),
        },
        cellClass: getCellClass(schemaKey),
        comparator: getComparator(schemaKey, {
            allowedValueFields,
        }),
        allowedAggFuncs: getAllowedAggFuncs(schemaKey),
        onCellDoubleClicked: editable ? undefined : openDetailModal,
        sort: getSort(sort, schemaKey),
        pinned: getPinnedValue(schemaKey && schemaKey.grid_column && schemaKey.grid_column.pinned),
        lockPosition: false, // this will get override if it's the image column
        ...additionalAttributes,
        editable: editable ? editableCellIsEditable : editableCellNotEditable,
        colId: schemaKey.field_name,
        ...(params.isServerSide && params.isGridTileView && { pinned: PinnedValue.UNPINNED }),
        ...(params.isServerSide && filterDef.filter === "agSetColumnFilter" && serverRollupEndpoint
            ? {
                  filterParams: {
                      ...(schemaKey.kind === Kinds.ASSORTMENT_LINK_KIND && {
                          cellRenderer: ({ value }) => {
                              return parseAssortmentName(value || "", schemaKey.field_value_delimiter).assortmentName;
                          },
                      }),
                      values: (fparams) => {
                          const blankValue = getBlankTextValue(true);
                          if (params.useConstraintValues) {
                              const values =
                                  schemaKey.constraint?.allowed_values?.map(
                                      ({ string_value }) => string_value || blankValue
                                  ) ?? [];
                              fparams.success(values ?? []);
                          } else if (schemaKey.field_name === ASSORTMENT_FIELD_NAME) {
                              const store = getStore();
                              const state = store.getState();
                              const collection = state.mutate.snapshots?.get(params.collectionId);
                              const collectionsRefs = collection?.getIn(["collections_refs"]);
                              const collectionNames = collectionsRefs
                                  ?.keySeq()
                                  ?.toArray()
                                  ?.map((key) => {
                                      return `${collectionsRefs.get(key)}${ASSORTMENT_NAME_DELIMITER}${key}`;
                                  });
                              fparams.success(collectionNames ?? []);
                          } else {
                              const itemDisplayProperty = fromJS(params.rawItemDisplayProperty);
                              const valueType = schemaKey.value_type || ValueTypes.STRING;
                              const gridApi = fparams.api as GridApi;
                              const currentFilters = Object.keys(gridApi.getFilterModel()).reduce((acc, filterKey) => {
                                  // Exclude current field as criteria
                                  if (filterKey !== schemaKey.field_name) {
                                      acc[filterKey] = gridApi.getFilterModel()[filterKey];
                                  }
                                  return acc;
                              }, {});
                              const query = buildFilterValuesQuery(
                                  schemaKey.field_name,
                                  params.merchantId,
                                  valueType,
                                  currentFilters,
                                  itemDisplayProperty
                              );

                              fetchJSON(serverRollupEndpoint, {
                                  method: "POST",
                                  body: JSON.stringify(query),
                              })
                                  .then((response: any) => {
                                      const { group_by } = response;
                                      fparams.success(
                                          (group_by || []).reduce((acc, { aggregation }) => {
                                              let groupKeyValue = getGroupKeyValue(valueType, aggregation.group_key);
                                              groupKeyValue =
                                                  groupKeyValue === undefined
                                                      ? getGroupKeyValue(ValueTypes.STRING, aggregation.group_key)
                                                      : groupKeyValue; // this is for UNSET_GROUP_KEY
                                              if (isBlankValue(groupKeyValue, valueType)) {
                                                  return acc.length && acc.some((it) => it === blankValue)
                                                      ? acc
                                                      : acc.concat(blankValue);
                                              }
                                              if (valueType === ValueTypes.DATE) {
                                                  const dateValue = parseStringIntoDate(groupKeyValue);
                                                  return acc.concat(
                                                      getFormattedDateObject(dateValue, params.defaultDateFormat) ||
                                                          blankValue
                                                  );
                                              }
                                              if (valueType === ValueTypes.BOOL) {
                                                  return acc.concat(
                                                      groupKeyValue ? formatMessage("Yes") : formatMessage("No")
                                                  );
                                              }

                                              return acc.concat(groupKeyValue);
                                          }, [])
                                      );
                                  })
                                  .catch((error) => {
                                      Sentry.captureException(error);
                                      fparams.success([]);
                                  });
                          }
                      },
                      refreshValuesOnOpen: true,
                  },
              }
            : {}),
        // override params by column
        ...(schemaKey?.gridColOptions && schemaKey?.gridColOptions),
    } as ColDef;
};

/**
 * Function to sync schema to current grid state.
 * Use cases of this function is:
 * 1. Renaming UDA will update schema, which in turns cause regneration of ColDef based on the schema which has original `display.hidden`.
 * This causes columns hidden through sidebar to re-appear
 */
export const syncGridToSchema = (schema: List<Map<string, any>>, columnApi: ColumnApi): List<Map<string, any>> => {
    // reduce the schemaKey list to a map where the key is the fieldname to make lookup easy
    const schemaMap = schema.reduce<Map<string, Map<string, any>>>(
        (acc, schemaKey) => acc.set(schemaKey.get("field_name"), schemaKey),
        Map()
    );

    const columns = columnApi.getAllGridColumns();
    // we generate the new view using the columns too keep order instact
    return columns.reduce<List<Map<string, any>>>((acc, column) => {
        const schemakey = schemaMap.get(column.getColId());
        if (!schemakey) {
            //we have to bailout in case the column is not on the schema
            return acc;
        }
        return acc.push(
            schemakey
                .setIn(["display", "hidden"], !column.isVisible())
                .setIn(["grid_column", "width"], column.getActualWidth())
        );
    }, List());
};

export const isEditable = (schemaKey, gridEditable = true) => {
    return gridEditable ? !get(schemaKey, ["display", "read_only"], false) : false;
};

export const getCellRenderer = (schemaKey): string => {
    if ((schemaKey.fe_lookup_type && schemaKey.fe_lookup_type.length > 0) || !!findCombinedDisplayObject(schemaKey)) {
        return "suggestionRenderer";
    }
    if (schemaKey.value_type === ValueTypes.DATE) {
        return "dateCellRenderer";
    }
    switch (schemaKey.kind) {
        case "agGroupCellRenderer":
            return "agGroupCellRenderer";
        case Kinds.IMAGE_URL:
            return "imageCellRenderer";
        case Kinds.RATING_STAR:
            return "ratingRenderer";
        case Kinds.ASSORTMENT_LINK_KIND:
            return "linkRenderer";
        case Kinds.INVENTORY_UNITS_PER_SIZE:
            return "inventoryUnitsRenderer";
        case Kinds.PACKS_SELECTED:
            return Editors.GenericReduxConnectedRenderer;
        default:
            return "defaultRenderer";
    }
};

export const getCellEditor = (schemaKey): string => {
    if (schemaKey.value_type === ValueTypes.NUMBER && !schemaKey.lookup_plan) {
        return Editors.NumberCellEditor;
    } else if (schemaKey.value_type === ValueTypes.BOOL) {
        return Editors.AgRichSelectCellEditor;
    } else if ([Kinds.PACKS_MAX_PER_DOOR, Kinds.PACKS_MAX_PER_PROD].includes(schemaKey.kind)) {
        return Editors.SingleChoiceCellEditor;
    } else if (schemaKey.kind === Kinds.PACKS_TYPE) {
        return Editors.PackTypeCellEditor;
    } else if (schemaKey.kind === Kinds.PACKS_SELECTED) {
        return Editors.MultipleChoiceCellEditor;
    } else if (
        (schemaKey.constraint && schemaKey.constraint.allowed_values) ||
        (schemaKey.fe_lookup_type && schemaKey.fe_lookup_type.length > 0) ||
        schemaKey.kind === Kinds.SIZE_PROFILE_SELECTED ||
        !!findCombinedDisplayObject(schemaKey)
    ) {
        return Editors.NuRichSelectCellEditor;
    } else if (schemaKey.kind === Kinds.SIZES_SELECTED) {
        return Editors.DropdownSizesEditor;
    } else if (schemaKey.value_type === ValueTypes.DATE) {
        return Editors.DatePickerCellEditor;
    }
    return "textEditor";
};

export const cellHasNotes = (params: CellClassParams) => {
    const { data, context, colDef } = params;
    const itemId = data?.fields?.id?.string_value;
    const collectionId = data?.fields?.[COLLECTION_ID_FIELD_NAME]?.string_value;
    const currentNoteValue = itemId && context.getNoteValue?.(itemId, colDef.colId, collectionId);

    return !!currentNoteValue;
};

export const getCellClass = (schemaKey): CellClassFunc => {
    return (params: CellClassParams) => {
        const classes = [];

        let cellClassByValueType = EXCEL_STYLES.STRING_CELL_CLASS;
        if (schemaKey.value_type === ValueTypes.NUMBER) {
            if (schemaKey.number_format) {
                if (schemaKey.number_format.currency) {
                    cellClassByValueType = EXCEL_STYLES.CURRENCY_CELL_CLASS;
                } else if (schemaKey.number_format.percentage) {
                    cellClassByValueType = EXCEL_STYLES.PERCENT_CELL_CLASS;
                }
            } else {
                cellClassByValueType = EXCEL_STYLES.INTEGER_CELL_CLASS;
            }
        }
        classes.push(cellClassByValueType);

        if (cellHasNotes(params)) {
            classes.push("noteIndicator");
        }

        return classes;
    };
};

export const getColumnFilter = (schemaKey) => {
    // Note: ag-grid v20 used a `suppressFilter` prop that would disable filters
    // Now that prop is deprecated in favor of just using `filter` prop. Moved
    // the logic to disable filters from `schemaGrid` to `getColumnFilter`.
    const suppressFilter =
        !get(schemaKey, ["grid_column", "show_filter_set"], true) &&
        !get(schemaKey, ["grid_column", "show_filter_box"], true) &&
        get(schemaKey, ["field_name"]) !== IMAGE_URL;
    let filter = suppressFilter ? false : "agSetColumnFilter";
    if (schemaKey.kind === Kinds.RATING_STAR || schemaKey.value_type === ValueTypes.DATE) {
        filter = "agSetColumnFilter";
    } else if (schemaKey.value_type === ValueTypes.NUMBER) {
        filter = "agNumberColumnFilter";
    } else if (
        (schemaKey.grid_column && schemaKey.grid_column.show_filter_box) ||
        schemaKey.kind === Kinds.MULTILINE_TEXT
    ) {
        filter = "agTextColumnFilter";
    }
    return { filter };
};

export const getValueGetter = (schemaKey) => {
    let getter;
    switch (schemaKey.kind) {
        case Kinds.FORMULA:
            getter = getGeneratedFormulaValueGetter(schemaKey);
            break;
        case Kinds.PRICE_WITH_STRIKETHROUGH:
            getter = getRangeValues;
            break;
        case Kinds.IMAGE_URL:
            getter = imageValueGetter;
            break;
        case Kinds.BRAND_ITEM_SIZES:
            getter = brandItemSizesValueGetter;
            break;
        default:
            switch (schemaKey.value_type) {
                case ValueTypes.NUMBER:
                    getter =
                        schemaKey.number_format &&
                        (schemaKey.number_format.currency || schemaKey.number_format.percentage)
                            ? currencyValueGetter
                            : numberValueGetter;
                    break;
                case ValueTypes.DATE:
                    getter = dateValueGetter;
                    break;
                default:
                    getter = defaultValueGetter;
                    break;
            }
            break;
    }
    return getter.bind(this, schemaKey);
};

export const getValueSetter = (schemaKey, params) => {
    // NOTE: in schema, selected_sizes do not have constraint freeform.
    // And it alloweds user to create options, not in the non-freeform checklist.
    if (schemaKey.kind === Kinds.SIZES_SELECTED || schemaKey.kind === Kinds.SIZE_PROFILE_SELECTED) {
        return defaultValueSetter;
    } else if (schemaKey.value_type === ValueTypes.DATE) {
        return dateValueSetter;
    } else {
        const nonFreeform =
            !schemaKey?.constraint?.freeform &&
            (!!schemaKey?.lookup_plan ||
                !!schemaKey?.fe_lookup_type ||
                (schemaKey?.constraint?.allowed_values?.length ?? 0) > 0);
        return nonFreeform ? nonFreeformCheckValueSetter.bind(this, schemaKey, params) : defaultValueSetter;
    }
};

export const getRangeValues = (schemaKey, getterParams: ValueGetterParams) => {
    schemaKey = (schemaKey.toJS?.() || schemaKey) as ISchemaKey;
    return map(schemaKey.formulas, (formula: string) => {
        const valueGetter = getGeneratedFormulaValueGetter({ ...schemaKey, formula });
        return valueGetter(schemaKey, getterParams);
    });
};

const normaliseValueByType = (value: string | number | boolean, valueType: ValueTypes): string | number | boolean => {
    let normalisedValue = value;

    if (valueType) {
        switch (valueType) {
            case ValueTypes.STRING:
                normalisedValue = value.toString();
                break;
            case ValueTypes.BOOL:
                normalisedValue = Boolean(value);
                break;
            case ValueTypes.NUMBER:
                // Parse to float instead of int to support potential decimals
                normalisedValue = safeParseFloat(value, 0);
                break;
            default:
                // Do nothing
                break;
        }
    }

    return normalisedValue;
};

const checkAllowed = (checklist, attributeName, value, valueType?: ValueTypes) => {
    const normalisedValue = valueType ? normaliseValueByType(value, valueType) : value;
    return (
        checklist.findIndex((item) => {
            const normalisedItemValue = valueType
                ? normaliseValueByType(item[attributeName], valueType)
                : item[attributeName];
            return normalisedItemValue === normalisedValue;
        }) !== -1
    );
};

export const nonFreeformCheckValueSetter = async (
    schemaKey,
    params,
    { colDef, newValue: _newValue, oldValue, data, api, node }
) => {
    let isAllowed = false;
    const newValue = typeof _newValue === "number" ? `${_newValue}` : _newValue;
    if (newValue !== oldValue) {
        const { getSuggestionData, merchantId } = params;
        const suggestionData = getSuggestionData() || {};
        const allowedValues = schemaKey?.constraint?.allowed_values || [];
        if (!newValue && newValue !== 0) {
            //Note: always allowed empty.
            isAllowed = true;
        } else if (allowedValues.length > 0) {
            isAllowed = checkAllowed(allowedValues, "string_value", newValue);
        } else if (schemaKey?.fe_lookup_type) {
            const { feLookupUrl, storeKey } = feLookupTypeGetter(schemaKey)(data.fields);
            if (suggestionData[storeKey] !== undefined) {
                isAllowed = checkAllowed(suggestionData[storeKey], "Code", newValue);
            } else {
                const response = await fetch(feLookupUrl, { method: "GET" });
                const responseJSON = await response.json();
                isAllowed = checkAllowed(responseJSON || [], "Code", newValue);
            }
        } else if (schemaKey?.lookup_plan) {
            const reservedLookup = isReversedLookup(schemaKey);
            const { interalLookup, dependency, lookupPlan } = internalGetter(schemaKey, merchantId)(data.fields);
            const storeKey = generateStoreKey(lookupPlan, dependency, colDef.field);
            if (suggestionData[storeKey] !== undefined) {
                isAllowed =
                    (reservedLookup
                        ? checkAllowed(suggestionData[storeKey], "format", newValue, schemaKey.value_type)
                        : checkAllowed(suggestionData[storeKey], "key", newValue, schemaKey.value_type)) ||
                    checkAllowed(suggestionData[storeKey], "key", newValue, schemaKey.value_type);
            } else {
                const result = await interalLookup({ data: dependency, fieldName: colDef.field });
                const checkArray = result || [];
                isAllowed =
                    (reservedLookup
                        ? checkAllowed(checkArray, "format", newValue, schemaKey.value_type)
                        : checkAllowed(checkArray, "key", newValue, schemaKey.value_type)) ||
                    checkAllowed(checkArray, "key", newValue, schemaKey.value_type);
            }
        }
    }
    const type = checkType(newValue);
    isAllowed && set(data, ["fields", colDef.field, type], newValue);
    // api.refreshCells({ rowNodes: [node] });
    return true;
};

export const getFilterValueGetter = (schemaKey) => {
    if ([ValueTypes.STRING, ValueTypes.DATE].includes(schemaKey.value_type)) {
        const getter = getValueGetter(schemaKey);
        return (_params) => {
            const value = getter(_params) ?? "";
            if (Array.isArray(value)) {
                return value;
            }
            return value.toUpperCase().trim();
        };
    }

    return undefined;
};

export const getValueByKey = (data, key, type = "string_value", defaultValue = "") =>
    get(data, ["fields", key, type], defaultValue) ||
    get(data, ["fields", `${AGGREGATE_COLUMN_PREFIX}${key}`, type], defaultValue);

type IValueGetterFunction = (
    schemaKey: Partial<ISchemaKey>,
    params: { data?: any; column?: any; context?: any; value?: any; node?: RowNode; colDef?: any }
) => string | number | any;

export const defaultValueGetter: IValueGetterFunction = (schemaKey, { column, data, context }) => {
    // in server rollups: number fields are returned as number_value but if you use an agregation function like count with % is returned as string
    const colId = column?.colId ?? schemaKey?.field_name ?? null;
    if (!colId) {
        return null;
    }
    const field = data?.fields?.[colId] || data?.fields?.[`${AGGREGATE_COLUMN_PREFIX}${colId}`];
    const type = context?.isServerRollup && field?.hasOwnProperty("number_value") ? "number_value" : "string_value";

    if (Iterable.isIterable(data)) {
        return (data as ImmutableIterable).getIn(["fields", colId, type], "");
    }

    return getValueByKey(data, colId, type);
};

export const brandItemSizesValueGetter = (schemaKey, { data }: { data: CartGridItem }) =>
    _.uniq(_.map(data?.entries, (entry: IGridEntry) => getSizeLabel(entry.size)));

export const getFormattedDateObject = (dateObject: IDate, dateFormat?: string) => {
    const value = fp.isString(dateObject)
        ? dateObject
        : dateObject
          ? `${dateObject?.month}/${dateObject?.day}/${dateObject?.year}`
          : undefined;
    const baseFormat = ["M/D/YYYY", "YYYY-MM-DD HH:mm:ss"];
    const result = isValidDateFormat(value, baseFormat)
        ? moment.utc(value, baseFormat).format(dateFormat || DEFAULT_MERCHANT_DATE_FORMAT)
        : "";
    return result;
};

export const parseStringDateIntoServerFormat = (value: string, merchantDateFormat: string) => {
    if (!value) {
        return DEFAULT_DATE_VALUE;
    }
    const date = moment.utc(value, merchantDateFormat || DEFAULT_MERCHANT_DATE_FORMAT);
    return date.isValid() ? date.format(SERVER_SNAPSHOT_DATE_F0RMAT) : DEFAULT_DATE_VALUE;
};

export const dateValueGetter = (schemaKey, props) => {
    const { column, data, colDef, context, node } = props;
    if (context?.isServerRollup && !node.group && column?.isAnyFunctionActive()) {
        return defaultValueGetter(schemaKey, props);
    }

    const defaultDateFormat = colDef?.cellRendererParams?.defaultDateFormat;
    const dateObject = getValueByKey(
        data,
        column.colId,
        "date_value",
        context?.isServerRollup && node?.group ? UNSET_GROUP_KEY : ""
    );

    if (context?.isServerRollup && node?.group && dateObject === UNSET_GROUP_KEY) {
        return null;
    }

    if (dateObject === UNSET_GROUP_KEY) {
        return UNSET_GROUP_KEY;
    }
    return getFormattedDateObject(dateObject, defaultDateFormat);
};

export const sizeManufacturedGetter = (_schemaKey, { data }) => {
    const nuSizeCodes = amphibiousGetIn(data, Item.FIELDS.NU_SIZE_CODES);
    const vendorSizeCodes = amphibiousGetIn(data, Item.FIELDS.VENDOR_SIZES);
    return nuSizeCodes || vendorSizeCodes || "";
};

export const sizeSelectedGetter = (_schemaKey, { data }) => {
    const selectedSizes = get(data, Item.FIELDS.SIZES_SELECTED);
    return selectedSizes || "";
};

interface IParseSelectedSizesReturn {
    allSizes: string[];
    curveSizes: string[];
    sizesAddedManually: string[];
}
export const parseSelectedSizes = (sizes = "", delimiter = SELECTED_SIZES_DELIMITER): IParseSelectedSizesReturn => {
    const [selectedString, manuallyAdded = ""] = sizes.split(MANUALLY_ADDED_SIZES_DELIMITER);
    const curveSizes = uniq(selectedString.split(delimiter).filter((it) => it));
    const sizesAddedManually = uniq(manuallyAdded.split(delimiter).filter((it) => it));
    return {
        allSizes: uniq(curveSizes.concat(sizesAddedManually)),
        curveSizes,
        sizesAddedManually,
    };
};

export const parseAssortmentName = (assortmentName: string, delimiter: string) => {
    const [name, id] = assortmentName.toString().split(delimiter);
    return { assortmendId: id, assortmentName: name || id };
};

export const getRollupType = (assortmentIds: string[] | string): RollupType => {
    const ids = Array.isArray(assortmentIds) ? assortmentIds : [assortmentIds];
    if (ids.length > 1) {
        return RollupType.Local;
    }

    const [collectionId] = ids;
    if (collectionId && !validator.isUUID(collectionId, 4) && /^\d+$/.test(collectionId)) {
        return RollupType.Server;
    }

    // normal colleciton
    return undefined;
};

export const parseAssortmentId = memoizeOne((assortmentId: string) => {
    const assortmentIds = assortmentId?.split("|").filter((it) => it);
    const rollupType = getRollupType(assortmentIds);

    return {
        isRollupMode: !!rollupType, // if they choose 1 assortment and hit view rollups, that assortment is going to be treat as an assortment without rollups
        baseAssortmentId: assortmentIds?.[0],
        assortmentIds,
        rollupType,
    };
});

export const joinSelectedSizes = (
    allSizes: string[],
    sizesAddedManually: string[],
    delimiter = ",",
    manuallyDelimiter = "|"
) => {
    return allSizes
        .filter((size) => size && !sizesAddedManually.includes(size))
        .join(delimiter)
        .concat(
            sizesAddedManually.length
                ? manuallyDelimiter.concat(sizesAddedManually.filter((it) => it).join(delimiter))
                : ""
        );
};

export const getSizesFieldsToUpdateFromSelectedSizes = (
    selectedSizes: string[],
    sizeRanges: ISizeRange[],
    rawItemDisplayProperty: ISchemaKey[],
    sizeManufactured: string
) => {
    let sizeCurveMethod = SizeCurveMethod.Manual;

    let shouldResetSizes = false;
    // Verify if size curve method is Vendor
    if (sizeManufactured && sizeRanges) {
        // @ts-ignore
        const manufacturedSizes = sizeManufactured.split(","); // tslint:disable-line
        const sizeRangeMatched = sizeRanges.find((sizeRange) =>
            areAllItemsContainedInList(manufacturedSizes, sizeRange.sizes)
        );

        if (areAllItemsContainedInList(selectedSizes, manufacturedSizes) && sizeRangeMatched) {
            sizeCurveMethod = SizeCurveMethod.VendorMatched;
        }
        shouldResetSizes = true;
    }
    // Update size method and clear size curve, size status and allocations

    return { sizeCurveMethod, sizeCurve: "", sizeCurveStatus: SizeCurveStatus.None, shouldResetSizes };
};

interface ISizeRelatedFields {
    sizeCurveMethodField?: IField;
    sizeCurveStatusField?: IField;
    sizeCurveField?: IField;
}
export const getSizeRelatedFields = (itemDisplayProperty: List<any>): ISizeRelatedFields => {
    const sizeCurveMethodField = itemDisplayProperty
        .find((field) => field && field.get("kind") === Kinds.SIZE_CURVE_METHOD)
        ?.toJS();
    const sizeCurveStatusField = itemDisplayProperty
        .find((field) => field && field.get("kind") === Kinds.SIZE_CURVE_STATUS)
        ?.toJS();
    const sizeCurveField = itemDisplayProperty
        .find((field) => field && field.get("kind") === Kinds.SIZE_PROFILE_SELECTED)
        ?.toJS();

    return {
        sizeCurveMethodField,
        sizeCurveStatusField,
        sizeCurveField,
    };
};

export const numberValueGetter = (schemaKey, params) => {
    const value = defaultValueGetter(schemaKey, params);
    if (
        value === "" ||
        (params.context?.isServerRollup && (value === UNSET_GROUP_KEY || isStringAggregationFunction(params.colDef)))
    ) {
        return value;
    } else {
        return isNaN(value) ? "" : Math.round(value);
    }
};

export const imageValueGetter = (schemaKey, { data }) =>
    getValueByKey(data, "image_url") || getValueByKey(data, "_product_id"); // force redraw of linked product

// eslint-disable-next-line consistent-return
export const currencyValueGetter: IValueGetterFunction = (schemaKey, { column, data, context, colDef }) => {
    if (!data || !data.fields) {
        return null;
    }

    const value = defaultValueGetter(schemaKey, { column, data, context });
    if (context?.isServerRollup) {
        if (value === UNSET_GROUP_KEY || isStringAggregationFunction(colDef)) {
            return value;
        }
    }
    if (!value || isNaN(value)) {
        return "";
    }
    return Math.abs(Number(value)); // Negative values are going to be disabled for all currency fields
};

export interface IAllocationFilters {
    index: number; // dimension index to look at
    field?: string; // option field to look at on dimension
    // one of
    eq?: string;
    // gt?: string;
    // lt?: string;
    in?: Matrix;
    gt?: number;
    gte?: number;
    lt?: number;
    lte?: number;
}

export const RESERVED_KEY = "_";

export const findDimensionValue = lodashMemoize(
    (snapshot: ImmutableMap<string, any>, valueToFind: string, attribute = "id") =>
        snapshot
            .getIn(["dimension_values", "list", "values"], List())
            .find((entry) => entry.getIn(["struct_value", attribute]) === valueToFind),
    (snapshot: ImmutableMap<string, any>, valueToFind: string, attribute: string) => {
        const dimensionId = snapshot.getIn(["field_map", "map", "fields", "id", "string_value"]);
        return `${dimensionId}_${valueToFind}_${attribute}`;
    }
);

type Comparator = (value) => boolean;

const doesMatchFilter = (filter: IAllocationFilters, column: string[], state, comparator: Comparator): boolean => {
    const {
        collection: { allocationDimensionIds },
        mutate: { snapshots },
    } = state;

    if (filter.field) {
        // compare dimension field against selection
        const node = findDimensionValue(snapshots.get(allocationDimensionIds[filter.index]), column[filter.index]);
        if (!node || !comparator(node.getIn(["struct_value", "fields", filter.field, "string_value"]))) {
            return false;
        }
    } else if (!comparator(column[filter.index])) {
        // compare bulk value at index against selection
        return false;
    }
    return true;
};

const getImageSchemaGridColumnWith = () => {
    const store = getStore();
    const state = store.getState();

    return state.collection.imageCellWidth || IMAGE_COLUMN_MIN_WIDTH;
};

const buildComparatorWithFilterRule = (filter: IAllocationFilters) => {
    if (filter.eq) {
        return (v) => v === filter.eq;
    } else if (filter.gt) {
        return (v) => v > filter.gt;
    } else if (filter.gte) {
        return (v) => v >= filter.gte;
    } else if (filter.lt) {
        return (v) => v < filter.gt;
    } else if (filter.lte) {
        return (v) => v <= filter.gte;
    } else if (filter.in) {
        return (v) => (filter.in.toArray() as MathArray).includes(v);
    }
    return () => true;
};

export const getUnitsWrapper = (
    bucketName: ItemFields.Bulks | ItemFields.Allocation,
    dimensionFiltersName?: GridParamType.DimensionFilters,
    classificationAttributeFilter?: GridParamType.CustomAttributeFilter,
    respectDimensionFilters = true,
    dontCountDuplicate = false
) => {
    const getUnits = (args, _math, scope): number[] => {
        const rowData = scope[RESERVED_KEY + ScopeKeys.Data];
        const formulaFilters: IAllocationFilters[] =
            args.join("|").includes(TotalPps.COST_VENDOR_PPS) || args.join("|").includes(TotalPps.RETAIL_VENDOR_PPS)
                ? args[4].compile().evaluate({}).toArray()
                : args.reduce(
                      (filters, arg) =>
                          // assume no scope is needed for speed
                          filters.concat(arg.compile().evaluate({}).toArray()),
                      []
                  );
        const dimensionFilters: string[][] = dimensionFiltersName ? scope[RESERVED_KEY + dimensionFiltersName] : [];
        const doorsWithinClassification: string[] = classificationAttributeFilter
            ? scope[RESERVED_KEY + classificationAttributeFilter]
            : null;
        const result = [];
        const allocationBag = scope[RESERVED_KEY + ScopeKeys.AllocationBag];

        const store = getStore();
        const state = store.getState();

        // To uncomment on corresponding ticket
        if (allocationBag) {
            // TODO: Measurement
            // console.time("getUnits");
            const rowId = get(rowData, Item.FIELDS.ID);
            let seenKeys = {};
            forEachAllocationBag(allocationBag, rowId, AllocationBagType[bucketName], (dimensions, value) => {
                // Prevent double count in case a race-condition happens and cause duplicate entries
                let dimensionValueKey: string;
                if (dontCountDuplicate && dimensions.length > 1) {
                    dimensionValueKey = dimensions.slice(1).join("_");
                    if (seenKeys[dimensionValueKey]) {
                        return;
                    }
                } else {
                    dimensionValueKey = dimensions.join("_");
                }

                seenKeys[dimensionValueKey] = true;
                const isProxyInclusion =
                    rowData?.proxyIndex === undefined ||
                    (rowData?.proxyIndex !== undefined && matchBreadcrumbs(rowData?.breadcrumbs, dimensions));
                if (!isProxyInclusion) {
                    return;
                }

                if (
                    respectDimensionFilters &&
                    doorsWithinClassification &&
                    !doorsWithinClassification.includes(dimensions[dimensions.length - 1])
                ) {
                    return;
                }

                if (formulaFilters.length || dimensionFilters.length) {
                    // dimension values are not in filter (skip if filter not populated)
                    if (respectDimensionFilters && !isDimensionInFilters(dimensionFilters, dimensions)) {
                        return; // skip column
                    }

                    // "or" filters within the same index
                    const inAllFilters: (boolean | undefined)[] = []; // collection of filters indexed by the condition index
                    const column = dimensions.concat(value);
                    for (const filter of formulaFilters) {
                        let inAnyFilters = !formulaFilters.length;
                        if (filter.eq) {
                            inAnyFilters =
                                inAnyFilters || doesMatchFilter(filter, column, state, (value) => value === filter.eq);
                        } else if (filter.in) {
                            // filter.in type is DenseMatrix but cannot be checked since it is not explosed by immutable.js
                            // eslint-disable-next-line dot-notation
                            const filterIn = filter.in.toArray() as number[];
                            inAnyFilters =
                                inAnyFilters ||
                                doesMatchFilter(filter, column, state, (value) => filterIn.includes(value));
                        }
                        inAllFilters[filter.index] = inAllFilters[filter.index] || inAnyFilters;
                    }

                    // "and" filters on different indexes by finding first false
                    if (inAllFilters.find((value) => value === false) === false) {
                        return; // skip column
                    }
                }
                const unit = safeParseInt(value, 0);
                if (unit > 0) {
                    result.push(unit);
                }
            });
            // TODO: Measurement
            // console.timeEnd("getUnits");
            seenKeys = null;
            return result;
        }

        // TODO: Measurement
        // console.time("getUnits");
        const bucket = rowData?.[bucketName]?.current || rowData?.[bucketName];

        let seenKeys = {};
        for (const row of bucket?.r ?? []) {
            const { c: column }: { c: string[] } = row;
            const dimensionValues = column.slice(0, column.length - 1);

            // Prevent double count in case a race-condition happens and cause duplicate entries
            let dimensionValueKey: string;
            if (dontCountDuplicate && dimensionValues.length > 1) {
                dimensionValueKey = dimensionValues.slice(1).join("_");
            } else {
                dimensionValueKey = dimensionValues.join("_");
            }

            if (seenKeys[dimensionValueKey]) {
                continue;
            }
            seenKeys[dimensionValueKey] = true;

            // If rows are exploded, only take exploded rows that represent row inside a bag.
            // Eg: If an exploded row represents specific [January, Door-1], we shouldn't count row that represents [January, Door-2]
            const isProxyInclusion =
                rowData?.proxyIndex === undefined ||
                matchBreadcrumbs(rowData?.breadcrumbs, dimensionValues as string[]);
            if (!isProxyInclusion) {
                continue;
            }

            if (
                respectDimensionFilters &&
                doorsWithinClassification &&
                !doorsWithinClassification.includes(dimensionValues[dimensionValues.length - 1])
            ) {
                continue;
            }

            if (formulaFilters.length || dimensionFilters.length) {
                // dimension values are not in filter (skip if filter not populated)
                if (respectDimensionFilters && !isDimensionInFilters(dimensionFilters, dimensionValues as string[])) {
                    continue; // skip column
                }

                // "or" filters within the same index
                const inAllFilters: (boolean | undefined)[] = []; // collection of filters indexed by the condition index
                for (const filter of formulaFilters) {
                    let inAnyFilters = !formulaFilters.length;
                    if (filter.eq) {
                        inAnyFilters =
                            inAnyFilters ||
                            doesMatchFilter(filter, column as string[], state, (value) => value === filter.eq);
                    } else if (filter.in) {
                        // filter.in type is DenseMatrix but cannot be checked since it is not explosed by immutable.js
                        // eslint-disable-next-line dot-notation
                        const filterIn = filter.in.toArray() as number[];
                        inAnyFilters =
                            inAnyFilters ||
                            doesMatchFilter(filter, column as string[], state, (value) => filterIn.includes(value));
                    }
                    inAllFilters[filter.index] = inAllFilters[filter.index] || inAnyFilters;
                }

                // "and" filters on different indexes by finding first false
                if (inAllFilters.find((value) => value === false) === false) {
                    continue; // skip column
                }
            }

            // if passed filters

            // Value after dimension ids are always quantity
            const unit = safeParseInt(column[column.length - 1], 0);

            if (unit > 0) {
                result.push(unit);
            }
        }

        // Let Garbage collector does its job
        seenKeys = null;

        // TODO: Measurement
        // console.timeEnd("getUnits");
        return result;
    };
    getUnits.rawArgs = true;
    return getUnits;
};

/**
 * Get bulk units sum by loop over all dimensions
 */
export const getBulkUnitsOverDimensions = (
    lowestDimensionId: string,
    data: any,
    allocationDimensions: IAllocationDimension[],
    dimensionFilters: string[][],
    allocationBag?: AllocationBag
): number => {
    if (!data) {
        return 0;
    }

    if (!data.bulks && !allocationBag) {
        return 0;
    }

    const allocationDimensionValueBreadcrumbs = getGetterBreadcrumbs(
        allocationDimensions?.filter((dimension) => dimension.subtype === AllocationDimensionKind.Generic) || [],
        -1
    );

    const bulks = data.bulks;
    if (allocationDimensionValueBreadcrumbs.length) {
        return allocationDimensionValueBreadcrumbs // example: sum all delivery dates for given door (only filtered door/dates if filter populated)
            .reduce((sum, breadcrumb) => {
                const thisBreadcrumbs = breadcrumb.concat([lowestDimensionId]);
                const isProxyInclusion =
                    data.proxyIndex === undefined || matchBreadcrumbs(data.breadcrumbs, thisBreadcrumbs);

                if (isDimensionInFilters(dimensionFilters, thisBreadcrumbs) && isProxyInclusion) {
                    if (allocationBag) {
                        sum +=
                            getAllocationBagValue(
                                AllocationBagType.bulks,
                                allocationBag,
                                data.fields.id.string_value,
                                thisBreadcrumbs
                            ) || 0;
                    } else {
                        sum += tableValueGetter(bulks, thisBreadcrumbs) || 0;
                    }
                }

                return sum;
            }, 0);
    }

    if (!isDimensionInFilters(dimensionFilters, [lowestDimensionId])) {
        return 0;
    }

    return allocationBag
        ? (getAllocationBagValue(AllocationBagType.bulks, allocationBag, data.fields.id.string_value, [
              lowestDimensionId,
          ]) ?? 0)
        : (tableValueGetter(bulks, [lowestDimensionId]) ?? 0);
};

type IFormulaFunction = (
    _schemaKey: any,
    { data }: { data: any; node?: { group: boolean }; context?: any }
) => number | "";

const getValueGivenFieldObject = (fieldObject: any) =>
    ["string_value", "number_value", "bool_value", "date_value"].reduce((value, key) => {
        if (!nullish(value) || !fieldObject || !fieldObject.hasOwnProperty(key)) {
            return value;
        }

        return fieldObject[key];
    }, null);
export const getValueGivenItemAndField = (fields: IItemField, fieldName: string) => {
    if (!fields || !fieldName || !fields.hasOwnProperty(fieldName)) {
        return null;
    }

    return getValueGivenFieldObject(fields[fieldName]);
};

/**
 * Formula Definition:
 * Get totals from entries.
 * @returns - Total count by type
 */
export const totalByImpl = () => {
    const getPrices = (args, _math, scope): number => {
        const totalType: ItemTotalType = args.toString();
        // undefined when pivoting is enabled
        const item: CartGridItem | undefined = scope[RESERVED_KEY + ScopeKeys.Data];
        return getTotalsFromEntries(item?.entries)?.[totalType] ?? 0;
    };
    getPrices.rawArgs = true;
    return getPrices;
};

export const calculatePpsTotalTileView = (allocationsPerSize, itemData, countryFilter, scopeContext, args) => {
    const costType = args[1].value;
    const discount = args[2].value;
    const currencyArg = args[3].value;
    const doorTotals = scopeContext.doorTotals;
    const ppsData =
        costType === TotalPps.COST_VENDOR_PPS
            ? itemData.fields?.cost_vendor_pps?.struct_value
            : costType === TotalPps.RETAIL_VENDOR_PPS
              ? itemData.fields?.retail_vendor_pps?.struct_value
              : null;
    const doorFilter = [0];
    doorFilter.push(doorTotals);
    const otherCountryFilter = getNotRequiredIndexes(doorFilter.flat(), countryFilter[0].eq);
    let totalPrice = 0;
    const filteredData =
        otherCountryFilter && otherCountryFilter.length > 0
            ? filterObject(allocationsPerSize, otherCountryFilter)
            : allocationsPerSize;
    for (const [allocKey, allocValue] of Object.entries(filteredData)) {
        const [, , allocSize] = allocKey.split("#");
        const price = parseFloat(ppsData[allocSize + "#" + currencyArg] as string) * (1 - discount / 100);
        totalPrice += price * (allocValue as { string_value: number })?.string_value;
    }
    return isNaN(totalPrice) ? 0 : Math.round((totalPrice + Number.EPSILON) * 100) / 100;
};

/**
 * Formula Definition:
 * Collects all field names and returns as array.
 *
 * Usage:
 *  fields(filterRegex? : string)
 *          where filterRegex - matcher to filter field names
 *
 * Examples:
 *  fields("^Cost") - will return all fields with property name "Cost"
 *
 * @returns - Array of item.fields.
 */
const getFieldsFormulaImpl = () => {
    const getValues = (args, _math, scope): string[] => {
        const itemData = scope[RESERVED_KEY + ScopeKeys.Data] ?? {};
        const fieldNameRegex = args[0]?.value;

        if (fieldNameRegex && itemData.fields) {
            return Object.keys(itemData.fields)
                .filter((key) => key.match(new RegExp(fieldNameRegex)))
                .reduce((acc: any, curr: string) => Object.assign(acc, { [curr]: itemData.fields[curr] }), {});
        }

        return itemData.fields;
    };
    getValues.rawArgs = true;
    return getValues;
};

/**
 * Formula Definition:
 * Returns all values from item fields.
 *
 * Usage:
 *  values(fields, property)
 *          where fields is items.fields. Usually, the fields() function should be used here.
 *                property - number_value or string_value
 *
 * Examples:
 *  values(fields(), "number_value")
 *
 * @returns - Array of values.
 */
const getValuesFormulaImpl = () => {
    const getValues = (args, property, scope): string[] => {
        const fieldProperty = property ?? "string_value";
        const fieldsData = args; // this is the data that comes out from the nested function.

        return fieldsData ? Object.keys(fieldsData).map((field) => fieldsData[field][fieldProperty]) : [];
    };
    // do not set rawArgs to true since the argument to it would be a function.
    return getValues;
};

function getNotRequiredIndexes(data: any, countryString: string): string[] {
    if (!data) {
        return [];
    }
    return Object.keys(data).filter((key) => data[key].classifications?.channel !== countryString);
}

function filterObject(inputObject: any, numbersToRemove: string[]): any {
    if (inputObject == null) {
        return {};
    }

    const filteredObject: any = {};
    Object.keys(inputObject).forEach((key) => {
        const [left, middle, right] = key.split("#");
        if (middle && !numbersToRemove.includes(middle)) {
            filteredObject[key] = inputObject[key];
        }
    });

    return filteredObject;
}

const customFunctions = {
    bulkUnits: getUnitsWrapper(ItemFields.Bulks, GridParamType.DimensionFilters, GridParamType.CustomAttributeFilter),
    allocationUnits: getUnitsWrapper(ItemFields.Allocation, undefined, undefined, false),

    // using for Grid View in Cart
    totalBy: totalByImpl(),
    fields: getFieldsFormulaImpl(),
    values: getValuesFormulaImpl(),
};

collectionMathJs.import(customFunctions, {});

export const mathJsSymbolIsField = (node: MathNode, mathJsInstance: Partial<MathJsStatic>) => {
    return node.isSymbolNode && !mathJsInstance[node.toString()];
};

export enum ScopeKeys {
    Data = "data",
    PoiToItemsToSizeBulks = "poiToItemsToSizeBulks",
    ReferenceItemInfo = "referenceItemInfo",
    FetchCollectionPOI = "onFetchCollectionPOI",
    Context = "context",
    AllocationBag = "allocationBag",
}

const regexIsNum = new RegExp("^-?d+(,d+)*(.d+(ed+)?)?$");
export const getGeneratedFormulaValueGetter = (schemaKey): IFormulaFunction => {
    const schemaKeyJS = (ImmutableMap.isMap(schemaKey) ? schemaKey.toJS() : schemaKey) as ISchemaKey;
    const dataFields = [];
    let code = { evaluate: (scope: any) => 0 };
    try {
        const formulaNode = collectionMathJs.parse(schemaKeyJS.formula);
        formulaNode.traverse((node) => {
            // if symbol and not built-in or custom
            if (mathJsSymbolIsField(node, collectionMathJs)) {
                const symbol: string = node.toString();
                const getterFunc = (data, gridApi?: GridApi, rowNode?: RowNode) => {
                    const value = data?.fields?.[symbol]?.string_value;
                    if (value === undefined || value === null) {
                        // Check to see if a column exists to use the grid api
                        if (gridApi && rowNode && schemaKey.kind === Kinds.FORMULA) {
                            const gridValue = gridApi.getValue(symbol, rowNode);
                            if (gridValue) {
                                return gridValue;
                            }
                        }
                        return schemaKeyJS.value_type === ValueTypes.STRING ? "" : 0;
                    }
                    if (regexIsNum.test(value)) {
                        return parseFloat(data?.fields?.[symbol]?.string_value) || 0;
                    }
                    return value;
                };
                dataFields.push([symbol, getterFunc]);
            }
        });
        code = formulaNode.compile();
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("Unable to parse schemaKeyJS.formula", schemaKeyJS.formula, schemaKeyJS.field_name, schemaKeyJS);
    }
    const getterFn = ({ data, context, column, node, ...rest }: ValueGetterParams) => {
        if (context?.isServerRollup) {
            const defaultValue =
                (data?.fields?.[schemaKey.field_name] ||
                    data?.fields?.[`${AGGREGATE_COLUMN_PREFIX}${schemaKey.field_name}`]) &&
                schemaKey.value_type === ValueTypes.NUMBER
                    ? 0
                    : "";
            return defaultValueGetter(schemaKeyJS, { data, context, column, ...rest }) || defaultValue;
        }
        const scope = {
            [RESERVED_KEY + ScopeKeys.Data]:
                data || (schemaKeyJS.groupFormula ? fp.map("data", node.allLeafChildren) : null), // apply formulas for groups
            [RESERVED_KEY + GridParamType.DimensionFilters]: context?.dimensionFilters || [],
            [RESERVED_KEY + GridParamType.CustomAttributeFilter]: context?.doorIdsWithinClasifications,
            [RESERVED_KEY + ScopeKeys.PoiToItemsToSizeBulks]: context?.poiToItemsToSizeBulksMap,
            [RESERVED_KEY + ScopeKeys.ReferenceItemInfo]: context?.[ScopeKeys.ReferenceItemInfo],
            [RESERVED_KEY + ScopeKeys.FetchCollectionPOI]: context?.[ScopeKeys.FetchCollectionPOI],
            [RESERVED_KEY + ScopeKeys.AllocationBag]: context?.[ALLOCATION_BAG_REF_CONTEXT_ATTRIBUTE]?.allocationBag,
            [RESERVED_KEY + ScopeKeys.Context]: context,
        };

        dataFields.forEach(([key, getter]) => {
            scope[key] = getter(data, (column as any)?.gridApi, node);
        });
        let result;
        try {
            result = code.evaluate(scope);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
        return result;
    };

    return (_schemaKey, getterParams: ValueGetterParams) => {
        const { data, api, column, colDef, context, node } = getterParams;
        let result;
        if (data?.type === SIZE_TOTALS_IDENTIFIER) {
            if (column.getColId() === CAPTURED_BULKS) {
                return "";
            }
            // We are on a Grouped Sizing Table CDP, and we are getting the totals row.
            api.forEachNode((rowNode) => {
                const nodeData = rowNode.data;
                const partialResult = getterFn({ ...getterParams, data: nodeData, node: rowNode }) ?? 0;
                result = !result ? partialResult : result + partialResult;
            });
        } else if (_schemaKey.groupFormula === false && node?.group) {
            result = null; // explicit check for consistency with the original implementation
        } else {
            result = getterFn(getterParams);
        }
        if (_schemaKey.value_type === ValueTypes.NUMBER) {
            const isStringAgg = context?.isServerRollup && isStringAggregationFunction(colDef);
            return isStringAgg || isFinite(result) ? result : "";
        }
        return result;
    };
};

export const getValueFormatter = (schemaKey: any) => {
    const field = schemaKey instanceof ImmutableMap ? (schemaKey as any).toJS() : schemaKey;
    let formatter = defaultValueFormatter;
    if (
        field.value_type === ValueTypes.NUMBER &&
        field.number_format &&
        (field.number_format.currency || field.number_format.percentage)
    ) {
        formatter = currencyOrPercentValueFormatter;
    } else if (field.value_type === ValueTypes.RANGE) {
        formatter = rangeValueFormatter;
    } else if (field.value_type === ValueTypes.DATE) {
        formatter = dateValueFormatter;
    } else if (field.kind === Kinds.BRAND_ITEM_SIZES) {
        formatter = arrayValueFormatter;
    }

    return formatter.bind(this, field);
};

export const rangeValueFormatter = (schemaKey, { value }): string | any[] => {
    // array is multidimensional, ex. [[...prices], [...originalPrices]]
    if (Array.isArray(_.head(value))) {
        return _.map(value, (v) => rangeValueFormatter(schemaKey, { value: v })).join(";"); // return string value for correct equals checks
    }
    if (Array.isArray(value) && !fp.isEmpty(value)) {
        const currency = schemaKey.number_format?.currency;
        const withCurrency = (x) =>
            currency ? currencyValueFormatter(currency.symbol, currency.decimal_places, x) : x;

        const min = Math.min(...value);
        const max = Math.max(...value);

        return min === max ? `${withCurrency(min)}` : `${withCurrency(min)} - ${withCurrency(max)}`;
    }
    return "";
};

export const currencyValueFormatter = (symbol: string, decimalPlaces: number, value: number | string) =>
    `${symbol}${safeFormatNumber(value, {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
    })}`;

export const arrayValueFormatter = (_, { value }) => {
    return value && Array.isArray(value)
        ? value.map((size: string) => size.charAt(0).toUpperCase() + size.slice(1)).join(", ")
        : [];
};

interface IFormatParams {
    columnApi: ColumnApi;
    colDef: ColDef;
    node: RowNode;
    api: GridApi;
    value: any;
    context: any;
    column?: any;
}

export const roundPercentage = (percent: number): string => {
    return percent.toFixed(1);
    // const zeroCount = getZeroCount(percent);
    // return percent.toFixed(zeroCount + 1);
};

export const defaultValueFormatter = (schemaKey, params: IFormatParams) => {
    const { columnApi, context } = params;
    const columns = columnApi ? (columnApi as any).getValueColumns() : [];
    const col = columns.find((column) => column.colId === schemaKey.field_name);
    const colAggFnc = col?.aggFunc;
    let value = params.value;
    if (colAggFnc && !context?.isServerRollup) {
        switch (colAggFnc) {
            case AggFuncs.COUNT_WITH_PERCENT.toLowerCase(): {
                value = params.node?.group ? value : 1;
                const percent =
                    (value * 100) / (params.node?.parent?.allChildrenCount ?? params.node?.allChildrenCount);
                value = `${value} (${isNaN(percent) ? 0 : roundPercentage(percent)}%)`;
                break;
            }
            case AggFuncs.SUM_WITH_PERCENT.toLowerCase(): {
                const aggValue =
                    params.node.parent?.aggData?.[params.colDef.colId] ?? params.node.aggData?.[params.colDef.colId];
                const percent = (params.value * 100) / aggValue;
                value = `${params.value} (${isNaN(percent) ? 0 : roundPercentage(percent)}%)`;
                break;
            }
            default:
        }
    }
    return value;
};

export const sizeCurveStatusValueFormatter: IValueGetterFunction = (schemaKey, { value, context, node }) => {
    // the formater is called from filter
    if (context?.isServerRollup && !node) {
        return value;
    }

    switch (value) {
        case SizingErrors.CurveNotFound:
        case SizingErrors.DoorCurveNotFound:
        case SizingErrors.SizeTotalsDotNotMatchBulks:
        case SizingErrors.PackConstraintsInfeasible:
        case SizingErrors.BulkPackConstraintsMismatch:
        case SizingErrors.SelectedSizesAndPacksMismatch:
            return SizeCurveStatus.Error;
        case SizingErrors.CurveContainsZeroUnits:
            return SizeCurveStatus.Partial;
        default:
            return value;
    }
};

export const sizeCurveMethodValueFormatter = (schemaKey, { value }) =>
    value === SizeRangesErrors.SizeRangesNotFound || value === SizeRangesErrors.SizeRangesDoNotMatch
        ? SizeCurveStatus.Error
        : value;

export const serverRollupCurrencyPercentValueFormatter = (schemaKey, colAggFnc, value) => {
    let symbol = "";
    let decimal_places = 2;
    if (schemaKey.number_format?.currency) {
        symbol = schemaKey.number_format.currency.symbol;
        decimal_places = schemaKey.number_format.currency.decimal_places;
    } else if (schemaKey.number_format?.percentage) {
        symbol = "%";
        decimal_places = schemaKey.number_format.percentage.decimal_places;
    }
    if (colAggFnc === AggFuncs.SUM_WITH_PERCENT.toLowerCase()) {
        const parts = `${value}`.match(/^([+-]?[0-9]*[.]?[0-9]+) \(([+-]?[0-9]*[.]?[0-9]+)%\)$/);
        if (parts === null) {
            return value;
        } else {
            const s = symbol || "";
            const num = Number(parts[1]);
            return `${s}${formatThousands(num.toFixed(decimal_places))} (${parts[2]}%)`;
        }
    } else if (colAggFnc === AggFuncs.COUNT_WITH_PERCENT.toLowerCase()) {
        const parts = value.match(/^([+-]?[0-9]*[.]?[0-9]+) \(([+-]?[0-9]*[.]?[0-9]+)%\)$/);
        if (parts === null) {
            return value;
        } else {
            return `${formatThousands(parts[1])} (${parts[2]}%)`;
        }
    } else {
        return "";
    }
};

export const currencyOrPercentValueFormatter = (
    schemaKey,
    { value, columnApi, colDef, node, context }: IFormatParams
) => {
    const columns = columnApi ? (columnApi as any).getValueColumns() : [];
    const col = columns.find((column) => column.colId === schemaKey.field_name);
    let returnValue;
    let symbol;
    let decimal_places;
    const colAggFnc = col?.aggFunc;

    if (schemaKey.number_format.currency) {
        symbol = schemaKey.number_format.currency.symbol;
        decimal_places = schemaKey.number_format.currency.decimal_places;
    } else if (schemaKey.number_format.percentage) {
        symbol = "%";
        decimal_places = schemaKey.number_format.percentage.decimal_places;
    }

    if (value === null || value === undefined || value === "") {
        returnValue = null;
    } else if (context?.isServerRollup && isStringAggregationFunction(colDef)) {
        returnValue = serverRollupCurrencyPercentValueFormatter(schemaKey, colAggFnc, value);
    } else if (isNaN(value)) {
        returnValue = "";
    } else if (
        col &&
        (colAggFnc === AggFuncs.COUNT.toLowerCase() || colAggFnc === AggFuncs.COUNT_WITH_PERCENT.toLowerCase())
    ) {
        let percentOfTotal = "";
        const num = node.group || (context?.isServerRollup && node.rowIndex === 0) ? value : 1; // pivot without grouping
        if (colAggFnc === AggFuncs.COUNT_WITH_PERCENT.toLowerCase()) {
            let percentage = (num * 100) / (node.parent?.allChildrenCount ?? node.allChildrenCount);
            percentage = isNaN(percentage) ? 0 : percentage;

            percentOfTotal = ` (${roundPercentage(percentage)}%)`;
        }
        returnValue = num + percentOfTotal;
    } else if (symbol || typeof decimal_places === "number") {
        if (symbol === "%") {
            const percent = (decimal_places ? Math.round(value * 100) / 100 : Math.round(value)).toString();
            returnValue = formatThousands(percent) + symbol;
        } else {
            let percentOfTotal = "";
            const s = symbol || "";
            const num = Number(value);
            if (node?.parent?.aggData && colAggFnc === AggFuncs.SUM_WITH_PERCENT.toLowerCase()) {
                let percentage = (num * 100) / node.parent.aggData[colDef.colId];
                percentage = isNaN(percentage) ? 0 : percentage;

                percentOfTotal = ` (${roundPercentage(percentage)}%)`;
            }
            returnValue =
                s + formatThousands(formatDecimals(roundValue(num, decimal_places), decimal_places)) + percentOfTotal;
        }
    }

    return returnValue;
};

export const dateValueFormatter = (schemaKey, { value }) => {
    return value;
};

export const packsTypeValueFormatter = (schemaKey, { value }) => {
    if (typeof value !== "string") {
        return value;
    }

    const formattedValue =
        { [PackTypes.CasePack]: "Case Packs", [PackTypes.PrePack]: "Pre-Packs", [PackTypes.Multiples]: "Multiples" }[
            value
        ] ?? ([null, undefined, ""].includes(value) ? "Eaches" : value); // Backwards compatibility
    return formattedValue ? formatMessage(formattedValue) : "";
};

export const getPivotIndex = (pivot, schemaKey) => {
    if (schemaKey.display && schemaKey.display.enable_pivot && pivot && pivot.columns && pivot.columns.length) {
        const pivotIndex = pivot.columns.indexOf(schemaKey.field_name);
        if (pivotIndex > -1) {
            return pivotIndex;
        }
    }
    return undefined;
};

export const getRowGroupIndex = (rowGroup, schemaKey) => {
    if (schemaKey.display && schemaKey.display.enable_group_by && rowGroup) {
        const rowGroupIndex = rowGroup.indexOf(schemaKey.field_name);
        if (rowGroupIndex > -1) {
            return rowGroupIndex;
        }
    }
    return undefined;
};

export const getAggFunction = (aggFunc, schemaKey) => {
    if (schemaKey.display && schemaKey.display.enable_aggregation && aggFunc) {
        const columnMatch = aggFunc.find((column) => column.column === schemaKey.field_name);
        if (columnMatch) {
            return columnMatch.aggFunc;
        }
    }
    return undefined;
};

export const getSort = (sort, schemaKey) => {
    const sortColumn = sort && sort.find((col) => col.colId === schemaKey.field_name);
    if (sortColumn) {
        return sortColumn.sort;
    } else {
        return null;
    }
};

interface IGetComparatorParams {
    allowedValueFields: object;
}
export const getComparator = (schemaKey, params: IGetComparatorParams) => {
    const { allowedValueFields = {} } = params;
    let comparator;
    switch (schemaKey.value_type) {
        case ValueTypes.NUMBER: {
            comparator = numberComparator;
            break;
        }
        case ValueTypes.RANGE: {
            comparator = rangeComparator;
            break;
        }
        default: {
            comparator = stringComparator;
        }
    }

    if (allowedValueFields[schemaKey.field_name]) {
        const allowedValueComparatorParams = {
            allowedValuesDictionary: allowedValueFields[schemaKey.field_name],
            fieldName: schemaKey.field_name,
        };
        comparator = allowedValuesComparator.bind(this, allowedValueComparatorParams);
    } else {
        comparator = comparator.bind(this, schemaKey);
    }
    return comparator;
};

export const stringComparator = (valueA, valueB, nodeA, nodeB) => {
    let valA;
    let valB;
    if (nodeA && nodeB && nodeA.group && nodeB.group) {
        valA = valueA;
        valB = valueB;
    } else {
        valA = validateStringValue(valueA);
        valB = validateStringValue(valueB);
    }
    return validateStringValue(valA).localeCompare(validateStringValue(valB));
};

export const validateStringValue = (value) => {
    let stringValue = "";
    if (typeof value === "string") {
        stringValue = value;
    } else if (typeof value === "number" || isArray(value)) {
        stringValue = value.toString();
    }
    return stringValue;
};

export const rangeComparator = (schemaKey, valueA, valueB) => {
    // get actual values in case of strikethrough multidimensional array, ex. [[...prices], [...originalPrices]]
    if (_.isArray(_.head(valueA))) {
        valueA = _.head(valueA);
    }
    if (_.isArray(_.head(valueB))) {
        valueB = _.head(valueB);
    }
    const minA = Math.min(...valueA);
    const minB = Math.min(...valueB);

    if (minA !== minB) {
        return minA - minB;
    }
    const maxA = Math.max(...valueA);
    const maxB = Math.max(...valueB);

    return maxA - maxB;
};

export const numberComparator = (schemaKey, valueA, valueB) => {
    return valueA - valueB;
};

export const allowedValuesComparator = ({ fieldName, allowedValuesDictionary }, valueA, valueB, nodeA, nodeB) => {
    let valA = valueA;
    let valB = valueB;

    if (nodeA && nodeB) {
        if (nodeA.group && nodeB.group) {
            valA = valueA;
            valB = valueB;
        } else {
            valA = defaultValueGetter({}, { column: { colId: fieldName }, data: nodeA.data }) || valA;
            valB = defaultValueGetter({}, { column: { colId: fieldName }, data: nodeB.data }) || valB;
        }
    }

    if (typeof valA === "number" && typeof valB === "number") {
        return valA - valB;
    } else {
        valA = allowedValuesDictionary[(valA || "").trim().toUpperCase()] || valA;
        valB = allowedValuesDictionary[(valB || "").trim().toUpperCase()] || valB;
        return (valA || "").localeCompare(valB);
    }
};

export const getAllowedAggFuncs = (schemaKey): string[] => {
    const allowedAggFuncs = [];
    if (schemaKey.display && schemaKey.display.enable_aggregation) {
        allowedAggFuncs.push(AggFuncs.COUNT.toLowerCase());
        allowedAggFuncs.push(AggFuncs.COUNT_WITH_PERCENT.toLowerCase());
        if (schemaKey.customAggregations) {
            allowedAggFuncs.push(...fp.map(fp.toLower, schemaKey.customAggregations));
        } else if (schemaKey.value_type === ValueTypes.NUMBER) {
            allowedAggFuncs.push(
                AggFuncs.SUM.toLowerCase(),
                AggFuncs.AVG.toLowerCase(),
                AggFuncs.SUM_WITH_PERCENT.toLowerCase()
            );
        }
    }
    return allowedAggFuncs;
};

export const feLookupTypeGetter = (schemaKeyObject) => {
    const dependencyArray = [];
    const [url, urlParams] = schemaKeyObject.fe_lookup_type.split("?");
    if (urlParams) {
        const urlParamsObj = new URLSearchParams(urlParams);
        urlParamsObj.forEach((item) => {
            if (item[0] === "$") {
                const argumentName = item.slice(2, -1);
                dependencyArray.push(argumentName);
            }
        });
    }
    const root = url.split("/").slice(-1)[0];
    const compiled = template(schemaKeyObject.fe_lookup_type);
    return (assortmentFields) => {
        const dependency = {};
        dependencyArray.forEach((dep) => {
            dependency[dep] =
                assortmentFields[dep] &&
                assortmentFields[dep].string_value &&
                encodeURIComponent(assortmentFields[dep].string_value.trim());
        });
        const result = compiled(dependency);
        const depKeys = Object.keys(dependency);
        let storeKey = depKeys.map((key) => dependency[key] || "none").join("-");
        storeKey = storeKey === "" ? root : `${root}-${storeKey}`;
        return { feLookupUrl: result, storeKey, dependency };
    };
};

export const buildFieldToValueTypeMap = memoizeOne(
    (jsItemDisplayProperty?: ISchemaKey[]): Map<string, ValueTypes> =>
        ImmutableMap(
            (jsItemDisplayProperty ?? []).reduce((acc, curr) => {
                acc[curr.field_name] = curr.value_type;
                return acc;
            }, {})
        )
);

export const internalGetter = (schemaKeyObj, merchantId, rawItemDisplayProperty?) => {
    const fieldToValueTypeMap = buildFieldToValueTypeMap(rawItemDisplayProperty);
    const { interalLookup, getDependencies: findDependencies } = getInternalLookUp(
        schemaKeyObj.kind,
        schemaKeyObj.lookup_plan,
        merchantId,
        fieldToValueTypeMap
    );
    const dependencyArray = findDependencies();
    return (assortmentFields) => {
        const dependency = dependencyArray.reduce(
            (acc, key) => ({
                ...acc,
                [key]: getFieldValue({ fields: assortmentFields }, key),
            }),
            {}
        );

        return { interalLookup, dependency, lookupPlan: schemaKeyObj.lookup_plan };
    };
};

export const dataGetter = (value, data: ISuggestionItem[]) => {
    // "" means the value is an empty string
    //  undefined means no such option in the data.
    if (value === "") {
        return "";
    }
    const item = (data || []).find(
        (suggestion) => suggestion.Value.trim() === value.trim() || suggestion.Code.trim() === value.trim()
    );
    if (!item) {
        return undefined;
    }
    return item.Code;
};

export const getSelectTerms = (lookup: ILookup): ILookupTerm[] => get(lookup, ["select", "terms"], []);
export const getWhereFields = (lookup: ILookup): ILookupWhereField[] => {
    let whereClause: ILookupWhere = lookup.where || ({} as any);
    while (whereClause.fallback) {
        whereClause = whereClause.fallback;
    }
    return whereClause.fields || ([] as any);
};
export const getDependencies = (lookup: ILookup): string[] => {
    return lookup
        ? getWhereFields(lookup)
              .filter((field) => !!get(field, ["column", "schema_column"]))
              .map((field) => get(field, ["column", "schema_column"]))
        : [];
};
export const getMissingDependencies = (lookup: ILookup, data: object): string[] =>
    getDependencies(lookup).filter((field) => get(data, ["fields", field, "string_value"], "") === "");

export const buildMissingDependenciesKnowingSchema =
    (schemaKey: any, rawItemDisplayProperty: any[]) =>
    (data: object): string[] =>
        getMissingDependencies(schemaKey.lookup_plan, data).map((columnId: string) => {
            // Lookup display name
            const field = rawItemDisplayProperty.find((property) => property.field_name === columnId);
            return field ? field.display_name : columnId;
        });

export const allowedValuesToAvailableValues = (allowedValues): IChoiceValue[] =>
    allowedValues
        ?.map((v) => v.string_value && v.id !== undefined && { id: v.id, label: v.string_value, enabled: true })
        .filter((v) => !!v) ?? [];

export const transformPacksToAvailableValues = (packs?: { [key: string]: IPackInfo }) =>
    !packs ? [] : Object.values(packs).map(({ id, name: label, active: enabled }) => ({ id, label, enabled }));

const getLabelGenerator = (rawItemDisplayProperty) => (dependency) => {
    return Object.keys(dependency)
        .map((key) => {
            const displaySchema = rawItemDisplayProperty.find((property) => property.field_name === key);
            const displayName = displaySchema ? displaySchema.display_name : key;
            const displayValue = parseInt(decodeURIComponent(dependency[key]), 10);
            return `${displayName}: ${displayValue || ""}`;
        })
        .join(" > ");
};
/**
 * Generate adittional attributes for a column on ag-grid
 */
export const getAdditionalAttributes = (schemaKey, params): Partial<ColDef> => {
    const {
        handleRowDrag,
        handleHeaderCheckboxSelection,
        handleCheckboxSelection,
        openDetailModal,
        onLinkProductToItem,
        canLinkProduct,
        getSuggestionData,
        setSuggestionData,
        rawItemDisplayProperty,
        merchantId,
        gridEditable,
        defaultDateFormat,
        onChangeDefaultItemVisibility,
        showDefaultItem,
        isServerSide,
        enableImageHeaderMenu,
        collectionId,
    } = params;
    const getDisplayName = (dependency: string[]) => {
        return dependency.map((key) => {
            const displaySchema = rawItemDisplayProperty.find((property) => property.field_name === key);
            return displaySchema ? displaySchema.display_name : key;
        });
    };

    if (schemaKey.kind === Kinds.IMAGE_URL) {
        return {
            rowDrag: handleRowDrag,
            lockPosition: true,
            lockVisible: true,
            lockPinned: true,
            suppressMenu: !enableImageHeaderMenu,
            menuTabs: MENU_GENERAL_TAB_ONLY,
            resizable: true,
            suppressColumnsToolPanel: true,
            headerCheckboxSelectionFilteredOnly: true,
            headerCheckboxSelection: handleHeaderCheckboxSelection,
            checkboxSelection: handleCheckboxSelection,
            pinned: "left",
            cellRendererParams: {
                fieldLookup: "image_url",
                productLinkLookup: "_product_id",
                openDetailModal,
                onLinkProductToItem,
                canLinkProduct,
                isServerSide,
            },
            minWidth: IMAGE_COLUMN_MIN_WIDTH,
            width: getImageSchemaGridColumnWith(),
            suppressFiltersToolPanel: true,
            maxWidth: IMAGE_COLUMN_MAX_WIDTH,
            ...(onChangeDefaultItemVisibility
                ? {
                      floatingFilterComponent: "defaultRowToggleRenderer",
                      floatingFilterComponentParams: {
                          suppressFilterButton: true,
                          onClick: onChangeDefaultItemVisibility,
                          showDefaultItem,
                      },
                  }
                : undefined),
            ...(isServerSide
                ? {
                      autoHeight: true,
                  }
                : undefined),
        } as ColDef;
    } else if (
        [Kinds.PACKS_TYPE, Kinds.PACKS_MAX_PER_DOOR, Kinds.PACKS_MAX_PER_PROD, Kinds.PACKS_SELECTED].includes(
            schemaKey.kind
        )
    ) {
        return {
            cellEditorParams: {
                getAvailableValues(stateChunk, itemFields) {
                    const packType = amphibiousGetIn(itemFields, Item.FIELDS.PACK_TYPE);
                    const enabledSizePacks = packType && SIZE_PACKS_EACHES !== packType;
                    if (stateChunk) {
                        const brandId = amphibiousGetIn(itemFields, Item.FIELDS.BRAND_ID);

                        if (schemaKey.kind === Kinds.PACKS_TYPE) {
                            const allowedPacks = parseSizePacks(amphibiousGetIn(itemFields, Item.FIELDS.PACK_IDS));
                            const availablePackTypes = allowedPacks
                                .map((pack) => {
                                    return (
                                        stateChunk.collection.sizePacks[brandId]?.[pack]?.active &&
                                        stateChunk.collection.sizePacks[brandId][pack]?.packType
                                    );
                                })
                                .filter((pack) => !!pack);
                            return allowedValuesToAvailableValues(
                                schemaKey.constraint?.allowed_values
                                    ?.filter(
                                        ({ string_value }) =>
                                            string_value === "" || availablePackTypes.includes(string_value)
                                    )
                                    .map(({ string_value: value }) => ({
                                        id: value,
                                        string_value: packsTypeValueFormatter(undefined, { value }),
                                    }))
                            );
                        }

                        if (enabledSizePacks) {
                            const allowedPacks = getSizePacksForItem(
                                itemFields,
                                stateChunk.collection.sizePacks,
                                packType
                            );
                            return transformPacksToAvailableValues(stateChunk.collection.sizePacks[brandId]).filter(
                                ({ id }) => allowedPacks.includes(id)
                            );
                        }

                        return [];
                    } else if (schemaKey.kind === Kinds.PACKS_MAX_PER_PROD && enabledSizePacks) {
                        return rangeFromAtoB(1, getSelectedSizePacksForItem(itemFields).length).map((v) => ({
                            id: `${v}`,
                            label: v,
                            enabled: true,
                        }));
                    } else if (schemaKey.kind === Kinds.PACKS_MAX_PER_DOOR && enabledSizePacks) {
                        const packsPerProd = amphibiousGetIn(itemFields, Item.FIELDS.PACKS_PER_PRODUCT);
                        if (!packsPerProd && packsPerProd !== 0) {
                            return [];
                        }
                        return rangeFromAtoB(1, +packsPerProd).map((v) => ({ id: `${v}`, label: v, enabled: true }));
                    }
                    return [];
                },
                statePaths: [SIZE_PACKS_STATE_PATH],
                parseCurrentValue: parseSizePacks,
            },
            ...(Kinds.PACKS_SELECTED === schemaKey.kind
                ? {
                      cellRendererParams: {
                          isServerSide,
                          statePaths: [SIZE_PACKS_STATE_PATH],
                          transformValueToDisplay: (data, stateChunk) => {
                              const packs = getSelectedSizePacksForItem(data);
                              if (packs.length) {
                                  const brandId = amphibiousGetIn(data, Item.FIELDS.BRAND_ID);
                                  const activePackNames = packs
                                      .map((pack) => {
                                          const packInfo = amphibiousGetIn(
                                              stateChunk,
                                              SIZE_PACKS_STATE_PATH.concat([brandId, pack])
                                          );
                                          return packInfo?.name;
                                      })
                                      .filter((pack) => !!pack);
                                  if (activePackNames.length) {
                                      return `(${activePackNames.length}) ${activePackNames.join(",")}`;
                                  }
                              }
                          },
                      },
                  }
                : {}),
        };
    } else if (schemaKey.value_type === ValueTypes.BOOL) {
        return {
            cellEditorParams: {
                values: [true, false],
            },
        };
    } else if (
        schemaKey.constraint &&
        schemaKey.constraint.allowed_values &&
        schemaKey.constraint.allowed_values.length
    ) {
        return {
            cellEditorParams: {
                freeform: schemaKey?.constraint?.freeform,
                values: schemaKey.constraint.allowed_values.map((val) => val.string_value),
            },
        };
    } else if (schemaKey.fe_lookup_type && schemaKey.fe_lookup_type.length > 0) {
        const getUrlDependencies = (dependency, data) => {
            return Object.keys(dependency).reduce((acc, key) => {
                const displaySchema = rawItemDisplayProperty.find((property) => property.field_name === key);
                const displayName = displaySchema ? displaySchema.display_name : key;

                if (get(data, ["fields", key, "string_value"], "") === "") {
                    acc.push(displayName);
                }
                return acc;
            }, []);
        };

        return {
            cellRendererParams: {
                freeform: schemaKey.constraint ? schemaKey.constraint.freeform : false,
                gridEditable,
                getSuggestionData,
                setSuggestionData,
                feLookupTypeGetter: feLookupTypeGetter.bind(this, schemaKey),
                isServerSide,
            },
            cellEditorParams: {
                freeform: schemaKey.constraint ? schemaKey.constraint.freeform : false,
                dataGetter,
                dependentUrlGetter: feLookupTypeGetter.bind(this, schemaKey),
                getUrlDependencies,
                labelGenerator: getLabelGenerator(rawItemDisplayProperty),
                getDisplayName,
            },
        };
    } else if (schemaKey.kind === Kinds.SIZE_PROFILE_SELECTED || !!findCombinedDisplayObject(schemaKey)) {
        const internalDataStoreGetter = (input, data: ILookupRawData[]) => {
            // "" means the value is an empty string
            //  undefined means no such option in the data.
            if (input === "") {
                return "";
            }
            const item = (data || []).find(
                (internalData) =>
                    internalData.value === input || internalData.key === input || internalData[EDITOR_DISPLAY] === input
            );
            if (!item) {
                return undefined;
            }

            // If lookup is by label, value should be based on `format`
            if (isReversedLookup(schemaKey)) {
                return item.format;
            }

            return item.key;
        };
        const combinedDisplaySetting = findCombinedDisplayObject(schemaKey);
        const updateDependantField = (schemaObj: ISchemaKey, e: RowNode, parentValue: string) => {
            if (schemaObj.kind === Kinds.SIZE_PROFILE_SELECTED) {
                const curveStatus = params.rawItemDisplayProperty.find((it) => it.kind === Kinds.SIZE_CURVE_STATUS);
                if (!curveStatus || !e) {
                    return;
                }
                let curveStatusValue;
                if (!parentValue) {
                    curveStatusValue = SizeCurveStatus.None;
                } else {
                    curveStatusValue =
                        parentValue === SizingErrors.Generic ? SizingErrors.CurveNotFound : SizeCurveStatus.Manual;
                }
                e.setDataValue(curveStatus.field_name, curveStatusValue);
            }
        };
        /**
         * This function gets called inside the SuggestionRenderer component when mounted or refreshed
         */
        const updateCombinedDisplayField = (rowNode: RowNode, rowData?: ILookupRawData) => {
            if (!combinedDisplaySetting) {
                return;
            }
            const combinedColumns = schemaKey.lookup_plan?.select?.terms || [];
            const allColumns = combinedColumns.filter((item) => item.column.schema_column !== "");
            // @ts-ignore
            const columnModel = rowNode.beans.columnModel as ColumnModel;

            if (rowData) {
                allColumns.forEach((obj) => {
                    const { column } = obj;
                    const dependentColumnName = column.schema_column;
                    const newDependentValue = getTransformedLookupValueByType(rowData.row[column.table_column]) ?? "";
                    const currentDependentValue = rowNode?.data?.fields?.[dependentColumnName]?.string_value || "";
                    // update only when needed.
                    if (
                        currentDependentValue !== newDependentValue &&
                        columnModel?.getPrimaryColumn(dependentColumnName)
                    ) {
                        rowNode.setDataValue(dependentColumnName, newDependentValue);
                    }
                });
            } else {
                allColumns.forEach((dependentCol) => {
                    const dependentSchemaColumn = dependentCol.column.schema_column;
                    const currentDependentValue = rowNode?.data?.fields?.[dependentSchemaColumn]?.string_value;
                    if (!currentDependentValue?.length) {
                        // NOTE: if value is empty, do nothing
                        // prevent empty check.
                        return;
                    }

                    // NOTE: editor already take care current column, avoid double update.
                    if (
                        dependentSchemaColumn !== schemaKey.field_name &&
                        columnModel?.getPrimaryColumn(dependentSchemaColumn)
                    ) {
                        rowNode.setDataValue(dependentCol.column.schema_column, "");
                    }
                });
            }
        };
        const getMissingDependenciesKnowingSchema = buildMissingDependenciesKnowingSchema(
            schemaKey,
            rawItemDisplayProperty
        );
        const missingDependenciesMessage = (missingDependencies: string[]) => {
            let displayMessage;
            if (schemaKey.kind === Kinds.SIZE_PROFILE_SELECTED) {
                displayMessage = format(
                    'Please enter |requiredFields| for this line item and then click "Find Size Ranges".',
                    {
                        requiredFields: missingDependencies.join(", "),
                    }
                );
            } else {
                displayMessage = format("Please enter |requiredFields| for this line item.", {
                    requiredFields: missingDependencies.join(", "),
                });
            }
            return displayMessage;
        };
        const labelGenerator = getLabelGenerator(rawItemDisplayProperty);
        return {
            cellEditorParams: {
                freeform: schemaKey.constraint ? schemaKey.constraint.freeform : false,
                getMissingDependencies: getMissingDependenciesKnowingSchema,
                internalGetter: internalGetter.bind(this, schemaKey, merchantId, rawItemDisplayProperty),
                dataGetter: combinedDisplaySetting ? internalDataStoreGetter : undefined,
                updateDependantField:
                    schemaKey.kind === Kinds.SIZE_PROFILE_SELECTED
                        ? updateDependantField.bind(this, schemaKey)
                        : undefined,
                getDisplayName,
                missingDependenciesMessage,
                getSuggestionData,
                setSuggestionData,
                labelGenerator,
            },

            cellRendererParams: {
                freeform: schemaKey.constraint ? schemaKey.constraint.freeform : false,
                gridEditable,
                getSuggestionData,
                setSuggestionData,
                updateCombinedDisplayField: combinedDisplaySetting ? updateCombinedDisplayField : undefined,
                getMissingDependencies: getMissingDependenciesKnowingSchema,
                internalGetter: internalGetter.bind(this, schemaKey, merchantId, rawItemDisplayProperty),
                labelGenerator,
                isServerSide,
            },
        };
    } else if (schemaKey.kind === Kinds.SIZE_CURVE_STATUS) {
        return {
            cellRendererParams: {
                isServerSide,
                getAlertInfo: (value) =>
                    value && {
                        severity:
                            value === SizingErrors.CurveContainsZeroUnits
                                ? SeverityMessages.Warning
                                : SeverityMessages.Error,
                        hasAlertInfo: [
                            SizeCurveStatus.Error,
                            SizingErrors.CurveNotFound,
                            SizingErrors.DoorCurveNotFound,
                            SizingErrors.CurveContainsZeroUnits,
                            SizingErrors.SizeTotalsDotNotMatchBulks,
                            SizingErrors.BulkPackConstraintsMismatch,
                            SizingErrors.PackConstraintsInfeasible,
                            SizingErrors.SelectedSizesAndPacksMismatch,
                        ].includes(value),
                        message: [
                            SizingErrors.CurveNotFound,
                            SizingErrors.DoorCurveNotFound,
                            SizingErrors.CurveContainsZeroUnits,
                            SizingErrors.SizeTotalsDotNotMatchBulks,
                            SizingErrors.BulkPackConstraintsMismatch,
                            SizingErrors.PackConstraintsInfeasible,
                            SizingErrors.SelectedSizesAndPacksMismatch,
                        ].includes(value)
                            ? formatMessage(value)
                            : null,
                    },
            },
        };
    } else if ([Kinds.EXPORT_ITEM_VALIDATION, Kinds.EXPORT_PO_VALIDATION].includes(schemaKey.kind)) {
        return {
            cellRendererParams: {
                isServerSide,
                getAlertInfo: (value, node) =>
                    value && {
                        severity:
                            value === ItemValidationErrors.Error ? SeverityMessages.Error : SeverityMessages.Warning,
                        hasAlertInfo: [ItemValidationErrors.Error, ItemValidationErrors.Warning].includes(value),
                        rowId: node.id,
                        kind: schemaKey.kind,
                        message: formatMessage("View errors"),
                    },
            },
        };
    } else if (schemaKey.kind === Kinds.SIZE_CURVE_METHOD) {
        return {
            cellRendererParams: {
                isServerSide,
                getAlertInfo: (value) =>
                    value && {
                        severity: SeverityMessages.Error,
                        hasAlertInfo:
                            value === SizeCurveMethod.Error ||
                            value === SizeRangesErrors.SizeRangesDoNotMatch ||
                            value === SizeRangesErrors.SizeRangesNotFound,
                        message:
                            value === SizeRangesErrors.SizeRangesDoNotMatch ||
                            value === SizeRangesErrors.SizeRangesNotFound
                                ? formatMessage(value)
                                : null,
                    },
            },
        };
    } else if (schemaKey.kind === Kinds.SIZES_SELECTED) {
        const getMissingDependenciesKnowingSchema = buildMissingDependenciesKnowingSchema(
            schemaKey,
            rawItemDisplayProperty
        );

        return {
            cellEditorParams: {
                getMissingDependencies: getMissingDependenciesKnowingSchema,
                merchantId,
                delimiter: schemaKey.field_value_delimiter || ",",
            },
        };
    } else if (schemaKey.kind === Kinds.ASSORTMENT_LINK_KIND) {
        return {
            cellRendererParams: {
                isServerSide,
                getLink: (rowNode) => {
                    // If row is used as group value, do not render as link
                    if (rowNode.aggData) {
                        return undefined;
                    }

                    // If row is group, get value assortment name value from children.
                    const rowData =
                        rowNode.group && rowNode.allLeafChildren?.length > 0
                            ? rowNode.allLeafChildren[0].data
                            : rowNode.data;
                    const assortmentId = parseAssortmentName(
                        get(rowData, Item.FIELDS.ASSORTMENT_FIELD_NAME, ""),
                        schemaKey.field_value_delimiter
                    ).assortmendId;
                    return assortmentId ? `/assortment/${assortmentId}/shop` : undefined;
                },
                target: "_blank",
            },
        };
    } else if (schemaKey.value_type === ValueTypes.DATE) {
        return {
            cellRendererParams: {
                isServerSide,
                defaultDateFormat: defaultDateFormat,
            },
            cellEditorParams: {
                defaultDateFormat: defaultDateFormat,
            },
        };
    } else if (schemaKey.value_type === ValueTypes.NUMBER) {
        return {
            cellEditorParams: {
                currency: schemaKey.number_format?.currency,
                isServerSide,
            },
        };
    } else if (schemaKey.allow_override_display_name && params.gridEditable) {
        return {
            headerComponent: "renameableHeaderComponent",
            suppressHeaderKeyboardEvent: (params) => params.event.key === "Enter",
            headerComponentParams: {
                fieldName: schemaKey.field_name,
            },
        };
    }

    return {};
};

export interface IDisplayField {
    field: ImmutableMap<string, any>;
    path: string[];
    formulaFunction?: IFormulaFunction;
}

export interface IDisplayFields {
    [s: string]: IDisplayField;
}

export interface ITotalFormulaFields {
    wholesale?: IDoorTotal;
    retail?: IDoorTotal;
    units?: Partial<IDoorTotal>;
}

/**
 * Converts itemDisplayProperty object into an ag-grid rowData object
 */
export const baseParseSchema = (itemDisplayProperty): any => {
    const requiredFieldNames = [];
    const desiredFieldNames = [];
    const searchableFields = [];
    const cardViewFields: IDisplayFields = {};
    const shopViewFields: IDisplayFields = {};
    const detailFields: IDisplayFields = {};
    let detailViewFields = List();
    let detailDisplayFields = List();
    let schemaFields = List();
    const visibleFields: IDisplayFields = {};
    const formulaFields: IDisplayFields = {};
    const totalFormulaFields: ITotalFormulaFields = {};

    const allowedValueFields: any = {};
    const viewItems = {
        sortableFields: {
            attribute: CardView.ALLOW_SORT,
            fields: [],
        },
        groupableFields: {
            attribute: CardView.ALLOW_GROUP,
            fields: [],
        },
        filterableFields: {
            attribute: CardView.ALLOW_FILTER,
            fields: [],
        },
    };

    if (itemDisplayProperty) {
        const store = getStore();
        const state = store.getState();
        const { isServerRollup } = state.collection;
        schemaFields = schemaFields.merge(itemDisplayProperty);

        itemDisplayProperty.forEach((field) => {
            if (!field) {
                return;
            }

            const valueField =
                isServerRollup && field.get("value_type") === ValueTypes.NUMBER ? "number_value" : "string_value";
            if (field.get("kind") === Kinds.FORMULA) {
                formulaFields[field.get("field_name")] = {
                    formulaFunction: getGeneratedFormulaValueGetter(field),
                    field,
                    path: ["fields", field.get("field_name"), "string_value"],
                };
                if (field.getIn(["detail_view", "is_total_units"])) {
                    totalFormulaFields.units = {
                        fieldName: field.get("field_name"),
                        formula: field.get("formula"),
                    };
                }
                if (field.getIn(["detail_view", "is_total_cost"])) {
                    totalFormulaFields.wholesale = {
                        fieldName: field.get("field_name"),
                        formula: field.get("formula"),
                        currency: field.getIn(["number_format", "currency"])?.toJS(),
                    };
                }
                if (field.getIn(["detail_view", "is_total_retail"])) {
                    totalFormulaFields.retail = {
                        fieldName: field.get("field_name"),
                        formula: field.get("formula"),
                        currency: field.getIn(["number_format", "currency"])?.toJS(),
                    };
                }
            }

            if (field.getIn(["detail_view", "display"])) {
                detailDisplayFields = detailDisplayFields.push(field);
            }

            if (field.get("value_type") === ValueTypes.STRING) {
                searchableFields.push(["fields", field.get("field_name"), "string_value"]);
            }

            if (field.get("card_view")) {
                CardView.FIELDS.forEach((cardField) => {
                    if (field.getIn(["card_view", cardField])) {
                        let formulaFunction;
                        if (field.get("kind") === Kinds.FORMULA) {
                            formulaFunction = getGeneratedFormulaValueGetter(field);
                        }
                        cardViewFields[cardField] = {
                            path: ["fields", field.get("field_name"), valueField],
                            field,
                            formulaFunction,
                        };
                    }
                });
                Object.keys(viewItems).forEach((key) => {
                    const item = viewItems[key];
                    const { attribute, fields } = item;
                    if (field.getIn(["card_view", attribute])) {
                        fields.push(field);
                    }
                });
            }

            if (field.get("shop_view")) {
                ShopView.FIELDS.forEach((shopField) => {
                    if (field.getIn(["shop_view", shopField])) {
                        let formulaFunction;
                        if (field.get("kind") === Kinds.FORMULA) {
                            formulaFunction = getGeneratedFormulaValueGetter(field);
                        }
                        shopViewFields[shopField] = {
                            path: ["fields", field.get("field_name"), "string_value"],
                            field,
                            formulaFunction,
                        };
                    }
                });
                Object.keys(viewItems).forEach((key) => {
                    const item = viewItems[key];
                    const { attribute, fields } = item;
                    if (field.getIn(["shop_view", attribute])) {
                        fields.push(field);
                    }
                });
            }

            if (field.get("detail_view")) {
                DetailView.FIELDS.forEach((detailField) => {
                    if (field.getIn(["detail_view", detailField])) {
                        let formulaFunction;
                        if (field.get("kind") === Kinds.FORMULA) {
                            formulaFunction = getGeneratedFormulaValueGetter(field);
                        }
                        detailFields[detailField] = {
                            path: ["fields", field.get("field_name"), valueField],
                            field: field.toJS(),
                            formulaFunction,
                        };
                    }
                });
            }

            if (field.get("detail_view") && field.getIn(["detail_view", "display"]) === true) {
                detailViewFields = detailViewFields.push(field);
            }

            if (field.getIn(SchemaField.FIELDS.ALLOWED_VALUES)) {
                const allowedValues = field.getIn(SchemaField.FIELDS.ALLOWED_VALUES);
                const padding = allowedValues.size.toString().length;
                const allowedValueDirectionary = allowedValues.reduce((dict, value, index) => {
                    const allowedValueEntryName = value.get("string_value").trim().toUpperCase();
                    dict[allowedValueEntryName] = index.toString().padStart(padding, "0");
                    return dict;
                }, {});
                allowedValueFields[field.get("field_name")] = allowedValueDirectionary;
            }

            if (field.getIn(["constraint", "required"])) {
                requiredFieldNames.push(field.get("field_name"));
            }

            if (field.getIn(["constraint", "desired"]) && !requiredFieldNames.includes(field.get("field_name"))) {
                desiredFieldNames.push(field.get("field_name"));
            }

            if (field.getIn(["display", "hidden"]) === false) {
                visibleFields[field.get("field_name")] = {
                    path: ["fields", field.get("field_name"), "string_value"],
                    field: field.toJS(),
                };
            }
        });
    }

    return {
        requiredFieldNames,
        desiredFieldNames,
        searchableFields,
        cardViewFields,
        detailFields,
        detailViewFields,
        detailDisplayFields,
        allowedValueFields,
        schemaFields,
        sortableFields: viewItems.sortableFields.fields,
        groupableFields: viewItems.groupableFields.fields,
        filterableFields: viewItems.filterableFields.fields,
        visibleFields,
        formulaFields,
        shopViewFields,
        totalFormulaFields,
    };
};
// TODO: Consider to only parse schema and store them in Redux once.
// Currently this helper function is used on-demand and potentially result in unnecessary overhead.
// Workaround memoize this for now
export const parseSchema = memoize(baseParseSchema);

/**
 * Remove struct_value wrapper
 */
export const translateItemsList = (values: any[], idPath?: string) => {
    const updatedValues = [];
    // map to track unque ids
    const uniqueValuesMap: { [id: string]: boolean } = {};
    let hasDuplicates = false;
    values.forEach((value) => {
        // This function can optionally track ids, this enables it
        if (idPath) {
            const idValue = get(value, idPath);
            // If previously found, generate new uuid for it
            if (uniqueValuesMap[idValue]) {
                set(value, idPath, uuid());
                hasDuplicates = true;
            }
            uniqueValuesMap[idValue] = true;
        }
        updatedValues.push(value.struct_value);
    });

    if (hasDuplicates) {
        try {
            Sentry.captureException(new Error("Duplicate assortment row id detected"));
        } catch {
            /* dont do anything */
        }
    }
    return updatedValues;
};

export const productsInAssortment = memoizeOne((items): { [key: string]: string[] } => {
    const productDict = {};
    (items || List()).toJS().forEach((item) => {
        const productId = item.fields._product_id && item.fields._product_id.string_value;
        if (productId) {
            const itemId = item.fields.id.string_value;
            if (productDict[productId]) {
                productDict[productId].push(itemId);
            } else {
                productDict[productId] = [itemId];
            }
        }
    });
    return productDict;
});

export const ARTIFICAL_ALLOCATION_DIMENSIONS_NODE = "NU_DOORS_ROOT";

export interface IPreference {
    field_name: string;
    display: {
        hidden: boolean;
    };
    grid_column: {
        width: number;
    };
}

const DEFAULT_WIDTH = 200;

const getSchemaMap = (schema) => {
    return schema.reduce((acc: object, current: IPreference) => ({ ...acc, [current.field_name]: current }), {});
};

const hideNewSchemaColumnsIfNeeded = (schemaColumns: IPreference, isDefaultView: boolean): IPreference => {
    if (isDefaultView) {
        return schemaColumns;
    }

    return {
        ...schemaColumns,
        display: {
            ...schemaColumns.display,
            hidden: true,
        },
    };
};
// TODO: REFACTOR THIS IN NU-33916
export const mergeWithDefaultSchema = (
    preference: IPreference[],
    schema: List<Map<keyof ISchemaKey, any>>,
    mergeRemovedProperties = true,
    isDefaultView = true,
    onSetImageCellDimensions: (dimensions: IImageCellDimensions) => void = undefined
) => {
    const propertiesWereRemoved = [];
    const merged = [];
    const schemaMap = getSchemaMap(schema.toJS());

    let changeDetected = false;
    const properties = preference && preference.length > 0 ? preference : schema.toJS();
    properties.forEach((newProperty) => {
        const property = schemaMap[newProperty.field_name];
        if (property) {
            if (newProperty.field_name === "image_url") {
                if (onSetImageCellDimensions) {
                    /* If the value of image column width coming from schema is less than the
                       allowed minimum value in the application, then instead take the minimum
                       allowed value ahead to maintain integrity of the image and cell width */
                    const actualWidth = Math.max(newProperty.grid_column.width, IMAGE_COLUMN_MIN_WIDTH);
                    const { width: imageCellWidth, height: imageCellHeight } =
                        getNewResizedImageCellDimensions(actualWidth);
                    onSetImageCellDimensions({ width: imageCellWidth, height: imageCellHeight });
                }
                property.grid_column = {
                    show_filter_box: false,
                    show_filter_set: false,
                };
            }
            const defaultProperty = { display: { hidden: false }, grid_column: { width: DEFAULT_WIDTH } };
            const mergedProperty = merge(defaultProperty, property, newProperty);

            if (mergedProperty.grid_column) {
                // set a hard-coded default column width if we encounter none, or if it's set to agGrid's "default" value of 0
                // without this, the column will retain the same width as before switching grid views
                mergedProperty.grid_column.width =
                    mergedProperty.grid_column.width && mergedProperty.grid_column.width > 0
                        ? mergedProperty.grid_column.width
                        : DEFAULT_WIDTH;
            }

            if (property.grid_column && property.grid_column.hasOwnProperty("show_filter_box")) {
                mergedProperty.grid_column.show_filter_box = property.grid_column.show_filter_box;
            }

            if (property.grid_column && property.grid_column.hasOwnProperty("show_filter_set")) {
                mergedProperty.grid_column.show_filter_set = property.grid_column.show_filter_set;
            }

            merged.push(mergedProperty);
        } else {
            if (newProperty.field_name !== ARTIFICAL_ALLOCATION_DIMENSIONS_NODE) {
                changeDetected = true;
                // when field was removed off master schema
                if (mergeRemovedProperties) {
                    merged.push(newProperty);
                    propertiesWereRemoved.push(newProperty.field_name);
                }
            } else {
                merged.push(newProperty);
            }
        }
    });

    const missingSchemaColumns = [];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Object.entries(schemaMap).forEach(([_key, schemaColumns]: [string, IPreference]) => {
        const found = merged.some((mergedPreference) =>
            [mergedPreference.field_name, "image_url"].includes(schemaColumns.field_name)
        );
        if (!found) {
            changeDetected = true;
            // when field was added on master schema
            missingSchemaColumns.push(hideNewSchemaColumnsIfNeeded(schemaColumns, isDefaultView));
        }
    });
    return {
        schema: fromJS([...merged, ...missingSchemaColumns]),
        propertiesWereRemoved,
        changeDetected,
    };
};

export const getInOrFormula = (
    key: IDisplayField | { path: string[] },
    data: ImmutableMap<string, any> | object,
    isServerSide?: boolean
): number => {
    let value;
    if (key) {
        if ((key as IDisplayField).formulaFunction && !isServerSide) {
            value = (key as IDisplayField).formulaFunction((key as IDisplayField).field, {
                data: amphibiousToJS(data),
            });
        } else {
            value = amphibiousGetIn(data, key.path);
        }
    }
    return safeParseFloat(value, 0);
};

export const getVariantColorIds = (variantColors: string): Array<{ string_value: string }> => {
    if (!variantColors) {
        return [];
    }

    return variantColors.split(",").map((variantColor) => ({
        string_value: variantColor.split(":")[1],
    }));
};

export const getCollectionSwatches = (product: ImmutableIterable): ICollectionSwatch[] => {
    const colorSwatches = product.getIn(Item.FIELDS.COLOR_SWATCHES, "");

    if (!colorSwatches) {
        return [];
    }

    return fp.compose(
        fp.map(([color, swatch_type, value, ref, label]) => ({
            color,
            value,
            swatch_type,
            selected: ref === product.getIn(Item.FIELDS.PRODUCT_ID),
            label,
        })),
        fp.map(fp.split("&&"))
    )(colorSwatches.split(","));
};

export const getCollectionSwatch = (product: ImmutableIterable): ICollectionSwatch => {
    const match = fp.find(
        fp.includes(amphibiousGetIn(product, Item.FIELDS.PRODUCT_ID)),
        amphibiousGetIn(product, Item.FIELDS.COLOR_SWATCHES, "").split(",")
    );

    if (match) {
        const [color, swatch_type, value, , label] = match.split("&&");
        return { color, swatch_type, value, label };
    }
    return null;
};

export const getVariantSwatches = (product: IProduct): ICollectionSwatch[] =>
    fp.compose(
        fp.map(({ ref, color_swatch, display_name }: IVariant) => ({
            color: color_swatch.color,
            value: color_swatch.value,
            swatch_type: color_swatch.swatch_type,
            label: display_name,
            selected: ref === product._id,
        })),
        fp.filter("color_swatch"),
        fp.get("items"),
        fp.find({ key: "color" })
    )(product?.__variants);

export const findCombinedDisplayObject = (schemaKey) => {
    return schemaKey?.lookup_plan?.display;
};

// Check if a lookup should be based on `key` OR `format`.
// Example use case: BLM where they want to select `product_type` by `product_type_name`.
export const isReversedLookup = (schemaKey) => {
    const lookupDisplay = findCombinedDisplayObject(schemaKey);
    if (!lookupDisplay) {
        return false;
    }

    // sample dropdown_format: <%= lookup.product_type %>;<%= lookup.product_type_name %>
    // sample format: <%= lookup.product_type_name %>
    // If format is prepended with delimited (;), we can assume it's reversed.
    return lookupDisplay.dropdown_format.indexOf(`;${lookupDisplay.format}`) >= 0;
};

export enum IdKeyTypes {
    ProductId = "_product_id",
    Id = "id",
}

export const getSkuOrId = (item: ImmutableMap<any, any>): string => {
    const idKey =
        item && amphibiousGetIn(item, ["fields", IdKeyTypes.ProductId]) ? IdKeyTypes.ProductId : IdKeyTypes.Id;
    const key = item && amphibiousGetIn(item, ["fields", idKey, "string_value"]);
    return key;
};

export const formatLightboxMedia = (images: string[], media: string[]): IProductMedia[] => {
    const lightboxMedia = [];
    images.forEach((imageUrl) => {
        lightboxMedia.push({
            type: MEDIA_TYPE_IMAGE,
            source: imageUrl,
        });
    });
    media.forEach((mediaEntry) => {
        const [typeCode, url] = mediaEntry.split("&&");
        if (typeCode === MEDIA_MAP[MEDIA_TYPE_VIDEO].toString()) {
            lightboxMedia.push({
                type: MEDIA_TYPE_VIDEO,
                source: withVideoSize(url, ""),
                poster: url,
            });
        } else if (typeCode === MEDIA_MAP[MEDIA_TYPE_360].toString()) {
            lightboxMedia.push({
                type: MEDIA_TYPE_360,
                source: url,
                manifest: url.replace("/serve", "/manifest"),
            });
        }
    });
    return lightboxMedia;
};

export const getColumnWithCommonAttributes = (
    schema: ISchemaToGridArg,
    schemaKeyOverrides = {},
    commonAttributes = {}
): ColDef | undefined => {
    const { schemaKey } = schema;
    if (schemaKey) {
        return {
            ...schemaToGrid({ ...schema, schemaKey: { ...schemaKey, ...schemaKeyOverrides } }),
            ...commonAttributes,
        };
    }
};

export const getAllSizesFromItems = (items: Immutable.Iterable<number, Immutable.Map<string, any>>) => {
    if (!items) {
        return [];
    }
    return items.reduce(
        (acc, item) => acc.concat(parseSelectedSizes(item.getIn(Item.FIELDS.SIZES_SELECTED, "")).allSizes ?? []),
        []
    );
};

export const genericParams: ISchemaToGridParams = {
    gridParams: {},
    allowedValueFields: {},
    openDetailModal() {},
    gridEditable: true,
    validate: false,
};

export const getTagFilteredByPoi = memoizeOne(
    (poiTags: List<any>, versionStatusesList: ICollectionVersionStatus[], currentPoi: string) =>
        getOrderedTaggedPois(poiTags, versionStatusesList).get(currentPoi)
);

export const getSortedPois = memoizeOne((poiEntities: { [collectionPoiId: string]: CollectionPOI }) => {
    const existingPois = Object.values(poiEntities ?? {});
    return existingPois.length
        ? existingPois.sort((poiA, poiB) => poiB.get("created_at_ms") - poiA.get("created_at_ms"))
        : [];
});

export const getLatestPoi = memoizeOne(
    (poi: string | undefined, poiEntities: { [collectionPoiId: string]: CollectionPOI }) => {
        let currentPoi = poi;
        if (!currentPoi) {
            const latestPoi = getSortedPois(poiEntities)[0];
            currentPoi = latestPoi ? latestPoi.get(PoiTag.POI_ID) : undefined;
        }
        return currentPoi;
    }
);

export const getVersionStatusForPoi = memoizeOne(
    (poi: string | undefined, poiTags: List<any>, versionStatusesList: ICollectionVersionStatus[]) => {
        const statusId = getOrderedTaggedPois(poiTags, versionStatusesList)?.get(poi);
        return versionStatusesList.find((status) => status.id === statusId);
    }
);

export const getOrderedTaggedPois = memoizeOne(
    (poiTags: List<any>, versionStatusesList: ICollectionVersionStatus[] = []) => {
        if (poiTags && versionStatusesList?.length) {
            const filteredPoiTags = poiTags.filter((tag) => {
                const statusId = tag.get(PoiTag.COLLECTION_VERSION_STATUS_ID);
                return versionStatusesList.some((status) => status.id === statusId && status.enabled);
            });
            return OrderedMap<string, string>(
                filteredPoiTags.map((tag) => [tag.get(PoiTag.POI_ID), tag.get(PoiTag.COLLECTION_VERSION_STATUS_ID)])
            );
        }
        return OrderedMap<string, string>();
    }
);

export const getLatestTaggedPoi = memoizeOne((poiTags: List<any>, versionStatusesList: ICollectionVersionStatus[]) =>
    getOrderedTaggedPois(poiTags, versionStatusesList).keySeq().first()
);

export const prepareDataToExportCollection = (params) => {
    const {
        supplier,
        exportOnlyVisibleColumns,
        exportOnlyVisibleRows,
        withImages,
        withUnits,
        withNotes,
        unitType,
        selectedAllocationDimensions,
        horizontalAllocationDimensions,
        type,
        actionMessage = null,
        includeAssortmentId = false,
        showExportToMerchant = false,
        collectionId,
        onCreateCollectionExport,
        gridApi,
        merchantName,
        exportFileName,
        view,
        layout,
        inventoryEnabled,
        isUpcExporting,
    } = params as { gridApi: GridApi; onCreateCollectionExport: (params: IExportParams) => void; [key: string]: any };
    // @ts-ignore `columnModel` is private.
    const columnApi = gridApi.columnModel.columnApi;
    const columns = (
        exportOnlyVisibleColumns === ExportCollectionSelectedSetting.All
            ? columnApi.getAllColumns()
            : columnApi.getAllDisplayedColumns()
    ).filter((column: Column) => column.getColId?.() !== CAPTURED_BULKS);
    const sortModel = getSortModelFromApi(columnApi);
    let rowOrder: { field: string; order: string };

    const excludeByColumnTypes = [ColumnTypes.AllDimensionTotal];
    let visibleColumnsList = [];
    columns.forEach((colObj) => {
        if (withImages && colObj.colId === IMAGE_URL) {
            visibleColumnsList.push(colObj.colId);
        } else {
            if (
                colObj.colId !== IMAGE_URL &&
                !getMetricColIdSuffix(colObj.colId) &&
                !excludeByColumnTypes.includes(colObj.userProvidedColDef.type)
            ) {
                if (
                    !inventoryEnabled ||
                    ![CloseoutColumns.TotalAvailableUnits, CloseoutColumns.AvailableUnitsBySize].includes(colObj.colId)
                ) {
                    visibleColumnsList.push(colObj.colId);
                }

                if (sortModel[0]?.colId === colObj.colId) {
                    rowOrder = { field: colObj.colId, order: sortModel[0].sort.toUpperCase() };
                }
            }
        }
    });
    // NOTE: when we group by column, ag-grid will generate a "ag-Grid-AutoColumn"
    // column name, which is not in our ItemDisplayProperty. Keep the same behavior with prod.
    const excludeList = ["ag-Grid-AutoColumn"];
    visibleColumnsList = visibleColumnsList.filter((columnName) => {
        return (
            !excludeList.includes(columnName) &&
            !isDoorColumn(columnName) &&
            !columnName.includes(ALLOCATION_DIMENSION_ID_PREFIX)
        );
    });

    const visibleRowsList = [];
    if (exportOnlyVisibleRows === ExportCollectionSelectedSetting.All) {
        gridApi.forEachNode((node) => {
            // Only include node that is NOT proxy OR first proxy (index=0) to prevent duplicate
            if (node.data && !node.data.proxyIndex) {
                visibleRowsList.push(node.data.fields.id.string_value);
            }
        });
    } else if (exportOnlyVisibleRows === ExportCollectionSelectedSetting.Visible) {
        gridApi.forEachNodeAfterFilter((node) => {
            // Only include node that is NOT proxy OR first proxy (index=0) to prevent duplicate
            if (node.data && !node.data.proxyIndex) {
                visibleRowsList.push(node.data.fields.id.string_value);
            }
        });
    } else {
        gridApi.getSelectedRows().forEach((node) => {
            visibleRowsList.push(node.fields.id.string_value);
        });
    }

    onCreateCollectionExport({
        merchantName,
        collectionId,
        supplier,
        visibleColumnsList,
        visibleRowsList,
        withImages,
        withNotes,
        exportFileName,
        withUnits,
        unitType,
        selectedAllocationDimensions,
        horizontalAllocationDimensions,
        rowOrder,
        type,
        actionMessage,
        includeAssortmentId,
        showExportToMerchant,
        view,
        layout,
        isUpcExporting,
    });
};

export const canUseXLS = navigator.userAgent.match(/iPad|iPhone|iPod/i) === null;

export const formatAssortmentPrice = (priceValue: number, priceSymbol: string) => {
    const numberSetting = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    return priceSymbol === ""
        ? formatNumber(isNaN(priceValue) ? 0 : priceValue, numberSetting)
        : formatCurrency(isNaN(priceValue) ? 0 : priceValue, CurrencyDictionary[priceSymbol] || "USD");
};

export const parseSizePacks = (sizePackString: string, delimiter = SIZE_PACKS_DELIMITER) =>
    sizePackString ? sizePackString.split(delimiter) : [];
export const getSizePacksForItem = (
    item,
    sizePacks: { [key: string]: { [key1: string]: IPackInfo } },
    packType: PackTypes | string
) => {
    if (!sizePacks || packType === SIZE_PACKS_EACHES || !packType) {
        return [];
    }
    const itemSizePacks = parseSizePacks(amphibiousGetIn(item, Item.FIELDS.PACK_IDS));
    const brandId = amphibiousGetIn(item, Item.FIELDS.BRAND_ID);
    return itemSizePacks.filter(
        (sizePackId) =>
            sizePacks?.[brandId]?.[sizePackId]?.packType === packType && sizePacks?.[brandId][sizePackId].active
    );
};
export const getSelectedSizePacksForItem = (item, selectedSizePacksSchema?: ISchemaKey) => {
    const selectedSizePacks: string = amphibiousGetIn(
        item,
        selectedSizePacksSchema
            ? [ItemFields.Fields, selectedSizePacksSchema.field_name, "string_value"]
            : Item.FIELDS.PACKS_SELECTED
    );
    return selectedSizePacks === "" ? [] : (selectedSizePacks?.split(SIZE_PACKS_DELIMITER) ?? []);
};

export const formatSizePackValues = (names: OrderedSet<string> | string[]) => names.join(SIZE_PACKS_DELIMITER);
export const changeSizePackField = (
    fieldName,
    item: ImmutableMap<string, any>,
    newValue: string = "",
    sizePacks?: { [key: string]: { [key1: string]: IPackInfo } },
    relevantSchemas: { packsPerProductSchema?: any | undefined; packsPerDoorSchema?: any | undefined } = {}
) => {
    item = item.setIn(["fields", fieldName, "string_value"], newValue);
    switch (fieldName) {
        case Item.FIELDS.PACKS_PER_DOOR[1]:
            return item;
        case Item.FIELDS.PACKS_PER_PRODUCT[1]:
            if (!relevantSchemas.packsPerDoorSchema || relevantSchemas.packsPerDoorSchema.hidden) {
                return item;
            }
            if (newValue) {
                return changeSizePackField(Item.FIELDS.PACKS_PER_DOOR[1], item, newValue, sizePacks, relevantSchemas);
            }
            return changeSizePackField(Item.FIELDS.PACKS_PER_DOOR[1], item, undefined, sizePacks, relevantSchemas);
        case Item.FIELDS.PACKS_SELECTED[1]:
            const newItem = item.deleteIn(Item.ALLOCATIONS).deleteIn(Item.PACK_ALLOCATIONS);
            if (!relevantSchemas.packsPerProductSchema || relevantSchemas.packsPerProductSchema.hidden) {
                return newItem;
            }
            if (newValue) {
                return changeSizePackField(
                    Item.FIELDS.PACKS_PER_PRODUCT[1],
                    newItem,
                    `${getSelectedSizePacksForItem(newItem).length}`,
                    sizePacks,
                    relevantSchemas
                );
            }
            return changeSizePackField(
                Item.FIELDS.PACKS_PER_PRODUCT[1],
                newItem,
                undefined,
                sizePacks,
                relevantSchemas
            );
        case Item.FIELDS.PACK_TYPE[1]:
            if (newValue && newValue !== SIZE_PACKS_EACHES) {
                const validSizePacksForItem = getSizePacksForItem(item, sizePacks, newValue as PackTypes);
                if (validSizePacksForItem) {
                    return changeSizePackField(
                        Item.FIELDS.PACKS_SELECTED[1],
                        item,
                        formatSizePackValues(validSizePacksForItem),
                        sizePacks,
                        relevantSchemas
                    );
                }
            }
            return changeSizePackField(Item.FIELDS.PACKS_SELECTED[1], item, undefined, sizePacks, relevantSchemas);
        default:
            return item;
    }
};

export const rangeFromAtoB = (a: number, b: number) =>
    a === b ? [a] : a > b ? [] : [a].concat(rangeFromAtoB(a + 1, b));
export const getItemValueByType = (item: IGridItem, field: string, valueType: ValueTypes) => {
    if (!item?.fields) {
        return;
    }
    switch (valueType) {
        case ValueTypes.NUMBER:
            // We used to store number value_type as `string_value`. Make this backward-compatible
            return item[ItemFields.Fields][field]?.number_value ?? item[ItemFields.Fields][field]?.string_value;
        case ValueTypes.BOOL:
            return item[ItemFields.Fields][field]?.bool_value;
        case ValueTypes.DATE:
            return item[ItemFields.Fields][field]?.date_value;
        default:
            return item[ItemFields.Fields][field]?.string_value;
    }
};

export const getDefaultFieldValueByType = (valueType: ValueTypes) => {
    let field;
    switch (valueType) {
        case ValueTypes.BOOL:
        case ValueTypes.DATE:
        case ValueTypes.NUMBER:
            field = {};
            break;
        default:
            field = {
                string_value: "",
            };
    }

    return field;
};

export const setItemValueByType = (item: IGridItem, field: string, value: any, valueType: ValueTypes) => {
    switch (valueType) {
        // We are storing number value_type as `string_value` now
        // case ValueTypes.NUMBER:
        //     set(item, [ItemFields.Fields, field], {
        //         number_value: value,
        //     });
        case ValueTypes.BOOL:
            set(item, [ItemFields.Fields, field], {
                bool_value: value,
            });
            break;
        case ValueTypes.DATE:
            set(item, [ItemFields.Fields, field], {
                date_value: value,
            });
            break;
        default:
            set(item, [ItemFields.Fields, field], {
                string_value: value,
            });
    }

    return item;
};

export const convertDefaultItemToItem = (defaultItem: IDefaultItem): IGridItem => {
    return {
        [ItemFields.Fields]: defaultItem?.[ItemFields.Fields]?.struct_value
            ? {
                  ...defaultItem?.[ItemFields.Fields]?.struct_value,
              }
            : null,
    };
};

export const productHasBeenSizedWithPacks = (item: Immutable.Map<string, any>): boolean => {
    const pack_alloc = amphibiousGetIn(item, [...Item.PACK_ALLOCATIONS, "r"], []);
    if (Iterable.isIterable(pack_alloc)) {
        return !!pack_alloc.size;
    }
    return pack_alloc.length > 0;
};

export const packSizesMismatch = (selectedSizes: string[], selectedPacksSizes: string[]) =>
    !!Set(selectedPacksSizes).subtract(selectedSizes).size;
export const itemHasPackSizesMismatch = (item: Map<string, any> | { fields: any }, sizePacks: IPackInfo[]) => {
    const { allSizes } = parseSelectedSizes(amphibiousGetIn(item, Item.FIELDS.SIZES_SELECTED));
    const selectedPacksSizes = sizePacks.reduce((acc, pack) => {
        if (!pack.active) {
            return acc;
        }
        let newAcc = acc;
        pack.packUnits.forEach((unit) => (newAcc = newAcc.add(unit.normalized_key)));
        return newAcc;
    }, Set<string>());
    return packSizesMismatch(allSizes, selectedPacksSizes.toJS());
};

export const getFieldNameToSchemaMapping = (itemDisplayProperty: List<Map<string, any>>) =>
    itemDisplayProperty.reduce((acc, curr) => acc.set(curr.get("field_name"), curr), ImmutableMap<string, any>());

export const getFieldNameToDisplayNameMapping = (itemDisplayProperty: List<Map<string, string>>) => {
    // IDP level field name
    let mapping = itemDisplayProperty.reduce(
        (acc, curr) => acc.set(curr.get("field_name"), curr.get("display_name")),
        ImmutableMap<string, string>()
    );

    // Global level field name
    mapping = mapping.set("collection.name", formatMessage("Assortment name"));
    return mapping;
};

// Helpers for TileView
export const getTileViewImageDimensions = (tileViewSize) => {
    const imageHeight =
        tileViewSize === TileViewSize.Small
            ? TILE_VIEW_IMAGE_HEIGHT_SMALL
            : tileViewSize === TileViewSize.Medium
              ? TILE_VIEW_IMAGE_HEIGHT_MEDIUM
              : TILE_VIEW_IMAGE_HEIGHT_LARGE;
    const imageWidth =
        tileViewSize === TileViewSize.Small
            ? TILE_VIEW_IMAGE_WIDTH_SMALL
            : tileViewSize === TileViewSize.Medium
              ? TILE_VIEW_IMAGE_WIDTH_MEDIUM
              : TILE_VIEW_IMAGE_WIDTH_LARGE;
    return {
        width: imageWidth,
        height: imageHeight,
    };
};

// `3` means `Show Units`, `Show Doors` unchecked and at least one `Cost` or `Retail` unchecked
const cartTotalHeightElement = (cartTotalsElements, defaultCartTotals) =>
    cartTotalsElements === 0
        ? 0
        : cartTotalsElements === 3
          ? defaultCartTotals
          : cartTotalsElements * TILE_VIEW_ITEM_SIZES.HEIGHT_LINE.DEFAULT;

export const getTileViewCellDimensions = memoizeOne((tileViewSize, tileSettings) => {
    const itemWidth = TILE_VIEW_ITEM_SIZES[tileViewSize].WIDTH;
    const moreLines = ["fifthLine", "sixthLine", "seventhLine", "eighthLine"];
    const activeMoreLines = moreLines.filter((line) => tileSettings[line]);
    const itemHeight =
        TILE_VIEW_ITEM_SIZES[tileViewSize].HEIGHT + activeMoreLines.length * TILE_VIEW_ITEM_SIZES.OFFSET.HORIZONTAL;
    const defaultCartTotalsHeight = TILE_VIEW_ITEM_SIZES[tileViewSize].CART_TOTALS;
    const linesHeight = {
        firstLine: TILE_VIEW_ITEM_SIZES.HEIGHT_LINE.DEFAULT,
        secondLine: TILE_VIEW_ITEM_SIZES.HEIGHT_LINE.DEFAULT,
        thirdLine: TILE_VIEW_ITEM_SIZES.HEIGHT_LINE.DEFAULT,
        fifthLine: TILE_VIEW_ITEM_SIZES.HEIGHT_LINE.DEFAULT,
        sixthLine: TILE_VIEW_ITEM_SIZES.HEIGHT_LINE.DEFAULT,
        seventhLine: TILE_VIEW_ITEM_SIZES.HEIGHT_LINE.DEFAULT,
        eighthLine: TILE_VIEW_ITEM_SIZES.HEIGHT_LINE.DEFAULT,
    };

    let hideSettingsPixels = 0;
    let hideUnitsAndDoors = 0;
    let cartTotalsElements = 0;

    for (const setting in tileSettings) {
        if ((!tileSettings[setting] || tileSettings[setting].length === 0) && !moreLines.includes(setting)) {
            hideSettingsPixels += linesHeight[setting] ?? 0;

            if (setting === SHOW_UNITS || setting === SHOW_DOORS) {
                hideUnitsAndDoors++;
                // `2` means `Show Units` and `Show Doors` unchecked
                if (hideUnitsAndDoors === 2) {
                    cartTotalsElements++;
                }
            } else if (setting === SHOW_TOTAL_COST || setting === SHOW_TOTAL_RETAIL) {
                cartTotalsElements++;
            }
        }
    }
    hideSettingsPixels += cartTotalHeightElement(cartTotalsElements, defaultCartTotalsHeight);
    return {
        height: itemHeight - hideSettingsPixels + TILE_VIEW_ITEM_SIZES.OFFSET.HORIZONTAL,
        width: itemWidth + TILE_VIEW_ITEM_SIZES.OFFSET.VERTICAL,
    };
});

// Helpers for sorting
export const biFilter = ({ list, conditionFn }) => {
    return list.reduce(
        (biList, item) => {
            biList[conditionFn(item) ? 0 : 1].push(item);
            return biList;
        },
        [[], []]
    );
};

// The sorting by numeric part will be only by integers and decimal numbers `/(?=[^\d.])/`.
// A number with exponential notation is considered as not valid number so it will be sorted alphabetically.
const getNumericPartFromItemWithInitialNumericPart = (item) => {
    if (isNaN(item) && (typeof item === "string" || item instanceof String)) {
        const [firstPart] = item.split(/(?=[^\d.])/g);

        if (firstPart && !isNaN(Number(firstPart))) {
            return firstPart;
        }
    }

    return item;
};

const getSortedListBasedOnInitialNumericPart = (list) => {
    return [...list].sort((a, b) => {
        return getNumericPartFromItemWithInitialNumericPart(a) - getNumericPartFromItemWithInitialNumericPart(b);
    });
};

const getSortedListNumericallyAndAlphabetically = (list) => {
    const [listA, listB] = biFilter({
        list,
        conditionFn: (item) => {
            return !isNaN(getNumericPartFromItemWithInitialNumericPart(item));
        },
    });

    return [...getSortedListBasedOnInitialNumericPart(listA), ...listB.sort((a, b) => a.localeCompare(b))];
};

const getSortedListBasedOnOrderListReference = (list, orderListReference: string[]) => {
    return [...list].sort((a, b) => orderListReference.indexOf(a) - orderListReference.indexOf(b));
};

export const getSortedSelectedSizes = (listToBeSorted) => {
    const [listA, listB] = biFilter({
        list: listToBeSorted,
        conditionFn: (item) => SIZES_ORDER_REFERENCE.includes(item),
    });

    return [
        ...getSortedListBasedOnOrderListReference(listA, SIZES_ORDER_REFERENCE),
        ...getSortedListNumericallyAndAlphabetically(listB),
    ];
};

export const validateItemsSchemaRules = (
    items: IGridItem[],
    validationProperties: List<Immutable.Map<string, any>> | undefined,
    itemDisplayProperty?: List<Immutable.Map<string, any>>,
    validationMode?: ValidationModes,
    context?
): ValidationResultWithIdentifier[] => {
    if (validationProperties) {
        collectionMathJs.import(validationLogic, { override: true });
    }
    const fieldValidationsResult = validateItemsWithFieldValidations(items, itemDisplayProperty, validationMode);
    const rowValidationsResult = validateItemsWithRowValidations(
        items,
        validationProperties,
        collectionMathJs,
        validationMode,
        context
    );
    const map = {};
    fieldValidationsResult.forEach((result) => (map[result.id] = result));
    rowValidationsResult.forEach((result) =>
        map[result.id]
            ? ["warnings", "errors"].forEach(
                  (field) => (map[result.id][field] = map[result.id][field].concat(result[field]))
              )
            : (map[result.id] = result)
    );
    return Object.values(map);
};

export const validateCollectionSchemaRules = (
    collectionData: IValidationCollectionData,
    validationProperties: List<Immutable.Map<string, any>> | undefined,
    context?
): ValidationResultWithIdentifier[] => {
    if (validationProperties) {
        collectionMathJs.import(validationLogic, { override: true });
    }
    const collectionValidationsResult = validateCollectionProperties(
        collectionData,
        validationProperties,
        collectionMathJs,
        context
    );
    const map = {};
    collectionValidationsResult.forEach((result) =>
        map[result.id]
            ? ["warnings", "errors"].forEach(
                  (field) => (map[result.id][field] = map[result.id][field].concat(result[field]))
              )
            : (map[result.id] = result)
    );
    return Object.values(map);
};

export const calculateAvgPPS = (
    itemData: IGridItem,
    priceType: string,
    currency: string,
    fieldName?: string
): number => {
    const ppsCollection = itemData?.fields?.[priceType]?.struct_value;
    const nonPPSValue = itemData?.fields?.[fieldName]?.string_value as string;

    if (!itemData?.fields?.[PPS_INDICATOR]?.bool_value || !ppsCollection) {
        return parseFloat(nonPPSValue ?? "0");
    }

    const currencyValues = Object.entries(ppsCollection)
        .filter(([key]) => key.endsWith(`#${currency}`))
        .map(([_, value]) => parseFloat(value as string));

    const currencySum = currencyValues.reduce((acc, value) => acc + value, 0);
    const currencyAvg = currencyValues.length > 0 ? currencySum / currencyValues.length : 0;

    return isNaN(currencyAvg) ? parseFloat(nonPPSValue ?? "0") : Math.round((currencyAvg + Number.EPSILON) * 100) / 100;
};

export const getViewSettingFields = memoizeOne((viewSettings = {}, rawItemDisplayProperty: ColDef[] = []) => {
    return Object.values(viewSettings).reduce((acc, viewSetting) => {
        if (typeof viewSetting === "string" || viewSettings instanceof String) {
            const fieldProperty = rawItemDisplayProperty.find((field) => field?.colId === viewSetting);
            if (fieldProperty) {
                acc[viewSetting as string] = fieldProperty;
            }
        }

        return acc;
    }, {} as any);
});

export const getViewSettingValues = memoizeOne((tileFieldSchemaHash, data, isServerSide, dimensionFilters) => {
    return Object.keys(tileFieldSchemaHash).reduce((target: {}, settingItem: string) => {
        const fieldSchema = tileFieldSchemaHash[settingItem];
        const getter = getValueGetter(fieldSchema);
        const settingItemValue = getter({
            column: { colId: fieldSchema.field_name },
            data,
            context: { isServerRollup: isServerSide, dimensionFilters },
        });

        return {
            ...target,
            [settingItem]: getValueFormatter(fieldSchema)({
                value: settingItemValue,
                context: { isServerRollup: isServerSide },
            }),
        };
    }, {});
});

export const getTotalWidthFromNoDimensionsNoPinnedVisibleColumns = memoizeOne((columns) => {
    const totalColumnsWidth = columns
        ? columns
              .filter((column) => !isDimensionColumn(column) && !column.pinned && column.visible)
              .reduce((acc, column) => (acc += column.actualWidth), 0)
        : 0;

    return parseInt(totalColumnsWidth, 10);
});

export const isDimensionColumn = (column) =>
    [
        ColumnTypes.DoorBulkQuantity,
        ColumnTypes.AllDimensionTotal,
        ColumnTypes.AllocationDimensionTotal,
        ColumnTypes.ClassificationTotal,
        ColumnTypes.NestedDimensionTotal,
        ColumnTypes.Metrics,
    ].includes(column?.colDef?.type);

/**
 *
 * @param doorClassificationSchema
 * @param doors
 * @param merchantPurchaseOrderDoorGroups
 * @returns filtered schema
 */
export const getFilteredClassificationSchema = (
    doorClassificationSchema,
    doors,
    merchantPurchaseOrderDoorGroups
): ISchemaKey[] => {
    let fieldToSetMap = doorClassificationSchema.reduce(
        (acc: Map<string, Set<string>>, schema: ISchemaKey) => acc.set(schema.field_name, Set<string>()),
        Map()
    );

    fieldToSetMap = doors.reduce(
        (acc, door) =>
            fieldToSetMap
                .keySeq()
                .reduce(
                    (acc2, classificationKey) =>
                        acc2.set(
                            classificationKey,
                            acc2.get(classificationKey).add(door.classifications[classificationKey] ?? "")
                        ),
                    acc
                ),
        fieldToSetMap
    );

    const schemaCopy = lodashCloneDeep(doorClassificationSchema);
    schemaCopy.forEach((schema) => {
        // Inject merchant purchase order door group as options
        if (schema.field_name === PURCHASE_ORDER_DOOR_GROUP_FIELD) {
            const merchantPODoorGroupOptions = merchantPurchaseOrderDoorGroups.map(
                (merchantPurchaseOrderDoorGroup) => ({
                    string_value: merchantPurchaseOrderDoorGroup.id,
                })
            );

            schema.constraint = {
                // First empty value is for [Blank] option
                allowed_values: [{ string_value: "" }].concat(merchantPODoorGroupOptions),
            };
        } else {
            if (schema.constraint) {
                schema.constraint.allowed_values = schema.constraint.allowed_values?.reduce(
                    (acc, value) =>
                        acc.concat(fieldToSetMap.get(schema.field_name).has(value.string_value) ? [value] : []),
                    []
                );
            }
        }
    });
    return schemaCopy;
};

type FieldValue = { bool_value: boolean } | { string_value: string };
type FieldAccumulator = Record<string, FieldValue>;

export const getFieldsByItems = (api: GridApi, rowNode: RowNode, items: List<IITemField>): FieldAccumulator =>
    items.reduce<FieldAccumulator>((acc, element) => {
        const type = element.type === "BOOLEAN" ? "bool_value" : "string_value";

        const value = api.getValue(element.colId, rowNode);

        if (value) {
            const fieldValue = { [type]: element.type === "BOOLEAN" ? value : value.toString() } as FieldValue;
            acc[element.colId] = fieldValue;
        }

        return acc;
    }, {});

export const getDisplayNamesForField = (schemaFields: string[], itemDisplayProperty: List<Map<string, any>>) => {
    if (!schemaFields?.length) {
        return "";
    }

    return schemaFields
        .map((field) => {
            const schemaKey = itemDisplayProperty.find((p) => p.get("field_name") === field);
            return schemaKey?.get("display_name") || field;
        })
        .join(", ");
};

export type ColumnStateList = ApplyColumnStateParams["state"];

/**
 * reset sorting to null from a ColumnState List
 */
export const removeSortFromColumnStateList = (columnState: ColumnStateList) =>
    columnState.map((state) => ({ ...state, sort: null }));

/**
 * Compare function for sorting allocation dimension values based on allocation dimension sequence of the merchant settings
 */
export const getSortOrderForAllocationDimensionValues = (
    allocationDimensions: IAllocationDimension[],
    dimensionId: string,
    valueA: string,
    valueB: string
) => {
    const currentAllocationDimension = allocationDimensions.find((item) => item.id === dimensionId);

    if (currentAllocationDimension) {
        const allocationDimensionValuesIdSorted = currentAllocationDimension.dimension_values.map((dimensionValue) =>
            dimensionValue.name.toLocaleLowerCase()
        );
        return allocationDimensionValuesIdSorted.indexOf(valueB?.toLocaleLowerCase()) >
            allocationDimensionValuesIdSorted.indexOf(valueA?.toLocaleLowerCase())
            ? -1
            : 1;
    }
};

/**
 * Compare function for sorting an auto group column
 */
type SortOrderForAutoGroupColumnParams = {
    allowedValueFields;
    gridParams: IGridParamsQueryParam;
    itemDisplayProperty?: List<any>;
    allocationDimensions: IAllocationDimension[];
    valueA;
    valueB;
    nodeA?: RowNode;
    nodeB?: RowNode;
};
export const getSortOrderForAutoGroupColumn = ({
    allowedValueFields,
    gridParams,
    itemDisplayProperty,
    allocationDimensions,
    valueA,
    valueB,
    nodeA,
    nodeB,
}: SortOrderForAutoGroupColumnParams): number => {
    const rowGroup = gridParams[GridParamType.RowGroup];
    const fieldName = rowGroup?.[0];
    const displayProperty = itemDisplayProperty?.find((field) => field && field.get("field_name") === fieldName);

    if (displayProperty) {
        const schemaKey = displayProperty.toJS();
        const comparatorFunc = getComparator(schemaKey, { allowedValueFields });
        return comparatorFunc.bind(this)(valueA, valueB, nodeA, nodeB);
    }

    if (isAllocationDimensionId(fieldName)) {
        return getSortOrderForAllocationDimensionValues(allocationDimensions, fieldName, valueA, valueB);
    }
    return valueA == valueB ? 0 : valueA > valueB ? 1 : -1;
};

export const getTargetsAndFilters = (targets, targetsBag) => {
    if (!targets) {
        return undefined;
    }

    const values = targets.reduce((acc, target) => {
        const bagValues = targetsBag.get(`${target.id}${BAG_VALUE_PARAMS_SEPARATOR}${AllocationBagType.target}`);
        acc.push({ filters: target.filters, values: bagValues?.toJS().map.fields });
        return acc;
    }, []);

    return values;
};

type AgGridFields = { [key: string]: { string_value: string } };
const checkFilters = (filters: FinancialTargetFilter[], fields: AgGridFields) => {
    return filters.every((filter) => {
        const filterValue = fields[filter.field_name]?.string_value;
        if (filterValue) {
            return filterValue === filter.value;
        }
        return false;
    });
};

export type DistributionTargets = {
    filters: FinancialTargetFilter[];
    values: { [key: string]: { string_value: string } };
}[];

export type AllItems = string[] | AllItems[];
export const buildSpreadCurve = (
    distributionTargets: DistributionTargets,
    allItems: AllItems,
    fields: AgGridFields
) => {
    const spread = distributionTargets?.find((target) => checkFilters(target.filters, fields))?.values;
    return allItems.map((item) => {
        const [delivery, door] = item;

        const bagValue = spread?.[`${delivery}${BAG_VALUE_PARAMS_SEPARATOR}${door}`];

        if (bagValue) {
            return Number(bagValue.string_value);
        }

        return 0;
    });
};

const parseDeliveriesCurve = (
    delivery: string,
    spread: {
        [key: string]: {
            string_value: string;
        };
    }
) => {
    if (!spread) {
        return 0;
    }
    const deliveryTotalValue = Object.keys(spread).reduce((acc, key) => {
        const currentDelivery = key.split(BAG_VALUE_PARAMS_SEPARATOR)[0];

        if (delivery === currentDelivery) {
            acc += Number(spread[key]?.string_value);
        }

        return acc;
    }, 0);

    return deliveryTotalValue;
};

export const buildTotalSpreadCurve = (
    distributionTargets: DistributionTargets,
    deliveries: string[],
    fields: AgGridFields
) => {
    const spread = distributionTargets?.find((target) => checkFilters(target.filters, fields))?.values;
    const curve: number[] = deliveries.reduce((acc, delivery) => {
        const deliveryTotalValue = parseDeliveriesCurve(delivery, spread);

        acc.push(deliveryTotalValue);
        return acc;
    }, []);

    return curve;
};

export const getNewUpcValues = (oldSizeValues, newSizeValues, oldUpcValues) => {
    const newUpcArr = [];
    const oldSizeArr = oldSizeValues?.replace("|", "")?.split(",");
    const newSizeArr = newSizeValues?.replace("|", "")?.split(",");
    const oldUpcArr = oldUpcValues?.replace("|", "")?.split(",");

    newSizeArr?.forEach((newSize) => {
        if (undefined != oldSizeArr && oldSizeArr.includes(newSize)) {
            const oldIndex = oldSizeArr.indexOf(newSize);
            const oldUpc = oldUpcArr[oldIndex];
            newUpcArr.push(oldUpc);
        } else {
            newUpcArr.push("");
        }
    });

    return newUpcArr.join(",");
};
